// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:36:41.438Z
// Property: 73TwentyFive (ID: 6737460151191765)
// Collections: 20 amenities, 15 floorplans (live), 79 photos, 71 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191765",
  "property_external_id": "5026525",
  "property_zillow_url": "https://www.zillow.com/apartments/maumelle-ar/river-pointe/5Z7N9Z/",
  "property_apartments_url": "https://www.apartments.com/73twentyfive-maumelle-ar/jtmc965",
  "property_google_business_url": "https://www.google.com/maps/place/73TwentyFive/data=!4m2!3m1!1s0x0:0x9e978bf21dccae2a?sa=X&ved=2ahUKEwiuneKZvbySAxWIq4kEHR4UAZUQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321266756",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "73twentyfive",
  "property_name": "73TwentyFive",
  "property_website_url": "https://www.73twentyfive.com/",
  "property_domain": "https://www.73twentyfive.com/",
  "property_address": "7325 River Pointe Dr",
  "property_full_address": "7325 River Pointe Dr, North Little Rock, AR 72113",
  "property_address_1": "7325 River Pointe Dr",
  "property_address_2": null,
  "property_address_city": "North Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72113-6951",
  "property_address_zip": "72113",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "Maumelle",
  "property_address_latitude": "34.8249792",
  "property_address_longitude": "-92.38825159999999",
  "property_email": "riverpointe@rreafresidential.com",
  "property_phone": "(501) 758-6500",
  "property_call_tracking_phone": "501-298-4639",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At 73TwentyFive in North Little Rock, AR, experience stylish living with one, two, and three-bedroom floor plans, complemented by upgraded appliances and flooring. Enjoy a vibrant community featuring two sparkling pools, a 24-hour fitness center, and a bark park. Your next home awaits—schedule a tour or browse our availability!",
  "property_long_description": "Welcome to 73TwentyFive, your premier apartment community located in North Little Rock, AR! Offering a diverse selection of floor plans, including chic one-bedroom, spacious two-bedroom, and family-friendly three-bedroom apartments, we are committed to providing the perfect living space for everyone. Our homes feature modern upgrades, including upgraded appliances and flooring, ensuring that you experience comfort and style in every corner.\n\nAt 73TwentyFive, we believe in enhancing your lifestyle with top-notch amenities. Enjoy the convenience of our 24-hour fitness center equipped with free weights, allowing you to maintain an active lifestyle at your convenience. With two sparkling pools, you can relax and unwind on warm afternoons or take a refreshing dip anytime you desire. Our community also offers ample parking, 24/7 availability, and a dedicated courtesy officer for your peace of mind.\n\nPet lovers will adore our Bark Park, designed for your furry friends to enjoy outdoor play. Our clothes care center and payment options make laundry day effortless, while our commitment to ASSET PROTECT ensures your apartment remains a secure haven. Plus, rest easy with our 24-hour emergency maintenance services that address your needs promptly.\n\nDon’t miss the chance to transform your living experience. Find your new home today—browse our availability or schedule a tour to visit our vibrant community! Discover why 73TwentyFive is the perfect place to call home in North Little Rock. ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-7ff9-771c-96c7-aa2d2936cfd0.webp",
  "property_featured_image_media": {
    "alt_text": "Community lounge area with a TV, comfortable seating, and a dining table.",
    "public_id": "019e1e2f-7ff9-771c-96c7-aa2d2936cfd0",
    "storage_key": "property/6737460151191765/019e1e2f-7ff9-771c-96c7-aa2d2936cfd0.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "384",
  "property_year_built": "2006",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.35416666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://riverpointear.loftliving.com/login",
  "property_apply_now_url": "https://8921439.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-8992-75df-a7de-70d7095c077f.webp",
  "property_primary_logo_media": {
    "alt_text": "73 Twentyfive logo.",
    "public_id": "019e8523-8992-75df-a7de-70d7095c077f",
    "storage_key": "property/6737460151191765/019e8523-8992-75df-a7de-70d7095c077f.webp",
    "width": 1695,
    "height": 2400
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-114f-73f4-a94c-82a1b84e31ec.webp",
  "property_secondary_logo_media": {
    "alt_text": "The logo for 73 Twenty Five, featuring large white numbers '73' over the text 'TWENTY FIVE'.",
    "public_id": "019e1e2f-114f-73f4-a94c-82a1b84e31ec",
    "storage_key": "property/6737460151191765/019e1e2f-114f-73f4-a94c-82a1b84e31ec.webp",
    "width": 1667,
    "height": 1667
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-114f-73f4-a94c-82a1b84e31ec.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The logo for 73 Twenty Five, featuring large white numbers '73' over the text 'TWENTY FIVE'.",
    "public_id": "019e1e2f-114f-73f4-a94c-82a1b84e31ec",
    "storage_key": "property/6737460151191765/019e1e2f-114f-73f4-a94c-82a1b84e31ec.webp",
    "width": 1667,
    "height": 1667
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-103e-773d-a339-4057c66d9f40.webp",
  "property_mono_black_logo_media": {
    "alt_text": "73 Twenty Five logo",
    "public_id": "019e1e2f-103e-773d-a339-4057c66d9f40",
    "storage_key": "property/6737460151191765/019e1e2f-103e-773d-a339-4057c66d9f40.webp",
    "width": 1667,
    "height": 1667
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0a318a",
  "property_secondary_color": "#ffffff",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "715 - 1250",
  "property_sqft_min": "715",
  "property_sqft_max": "1250",
  "property_price_range": "875 - 1409",
  "property_price_min": "875",
  "property_price_max": "1409",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/73TwentyFive/",
  "property_instagram_url": "https://www.instagram.com/73twentyfive/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJL0LGBPGh0ocRKq7MHfKLl54",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=North+Little+Rock%2C+AR",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 73TwentyFive",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Community",
  "property_home_amenities_blurb": "<p>73TwentyFive Apartment Homes is nestled in North Little Rock, Arkansas, encircled by lakes, ponds, hiking, and biking trails! We are a mile away from the Arkansas River, with easy access to Maumelle Boulevard and I-430. Our pet-friendly <a href=\"/floor-plans/\">one, two, and three bedrooms for rent</a> are perfectly located minutes from downtown Little Rock with luxury and modern features throughout like walk-in closets, and breakfast bar. Residents love our exclusive events in the clubhouse with coffee and tea bar, 24-hour fitness center, and resort style swimming pool.</p>",
  "property_home_floorplans_blurb": "<p>Explore your way around scenic North Little Rock, AR, encircled by lakes, parks, hiking, and biking trails! We are just a mile from the infamous Arkansas River, with easy access to Maumelle Boulevard and Interstate 430. Find your way to 73TwentyFive <a href=\"/floor-plans/\">apartments</a> and take a tour today! Click the categories to see a few of the popular points of interest around town. Click the icons on the map for the address, distance, and directions to each location from 73TwentyFive Apartments.</p>",
  "property_home_gallery_blurb": "At 73TwentyFive in North Little Rock, AR, life is a blend of comfort and style. Choose from meticulously designed one, two, or three-bedroom apartments featuring modern upgrades, scenic views, and upscale amenities like a refreshing pool, fitness center, and serene walking trails. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At 73TwentyFive in North Little Rock, AR, our diverse floor plans cater to every lifestyle—from cozy one-bedroom retreats to spacious three-bedroom havens. Immerse yourself in the vibrant neighborhood, where local favorites and hidden gems await. Uncover the allure around our community and find your perfect home and adventure.",
  "property_home_reviews_blurb": "Experience comfortable living at 73TwentyFive in North Little Rock, AR, where residents cherish their newly renovated, spacious apartments. Enjoy the quiet atmosphere and stunning mountain views—\"There's no bug problems here!\" With impeccable service and family-friendly amenities, it’s no wonder tenants are thrilled to call this community home.",
  "property_neighborhood_blurb": "<p>Explore your way around scenic North Little Rock, AR, encircled by lakes, parks, hiking, and biking trails! We are just a mile from the infamous Arkansas River, with easy access to Maumelle Boulevard and Interstate 430. Find your way to 73TwentyFive <a href=\"/floor-plans/\">apartments</a> and take a tour today! Click the categories to see a few of the popular points of interest around town. Click the icons on the map for the address, distance, and directions to each location from 73TwentyFive Apartments.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>You'll feel at home upon arrival, and your pets are welcome. The choice is yours, with eight unique <a href=\"/floor-plans/\">floor plans</a> from which to select. Our amenities have been selected to provide comfort and convenience. You can start your day with a trip to our coffee and tea bar. Get a great workout anytime at our state-of-the-art fitness center. Swim a few laps or just cool off and catch some rays in our resort-style shimmering swimming pool. Your pets will love spending time exploring the cozy dog park. Our flexible rent payment program, online rent payment portal, and 24-hour emergency maintenance, make it easier to relax in lovely North Little Rock, AR.</p>",
  "property_applynow_blurb": "Welcome to 73TwentyFive in North Little Rock, AR, where stylish living meets unparalleled convenience. Our diverse floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes, offer the perfect haven. Enjoy 24-hour fitness, two sparkling pools, and a welcoming bark park—all designed for your comfort. Lease online today!",
  "property_contactus_blurb": "At 73TwentyFive in North Little Rock, AR, every floor plan, from cozy one-bedrooms to spacious three-bedrooms, is designed for your comfort and style. Whether you're seeking a serene retreat or a lively gathering space, our community has the perfect fit. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At 73TwentyFive in North Little Rock, AR, we offer diverse floor plans—one, two, and three-bedroom options—perfect for your lifestyle. Uncover the details that make our community unique by visiting our FAQs page for answers to your most pressing questions. Your ideal home awaits!",
  "property_floorplans_blurb": "<p>At 73TwentyFive, we have one, two, and three bedroom apartments for rent in North Little Rock. Search for floor plans by the maximum rent, the number of beds or baths, a specific floor plan, or an apartment number. Compare floor plans and find the one that’s right for you! <a href=\"/contact/\">Schedule a tour</a> to visit your new home today!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new <a href=\"/floor-plans/\">apartment home</a> quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "At 73TwentyFive in North Little Rock, AR, elevate your lifestyle with our diverse floor plans—choose from one, two, or three bedrooms. Enjoy generous amenities, from sparkling pools and a state-of-the-art fitness center to a dedicated bark park. Utilize our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At 73TwentyFive in North Little Rock, AR, friendship thrives in our inviting one, two, and three-bedroom apartments. With spacious floor plans designed for comfort and connection, you can enjoy life with loved ones. Great friends make great neighbors—refer a friend today and enhance our vibrant community!",
  "property_residentaccess_blurb": "At 73TwentyFive in North Little Rock, AR, your ideal home awaits, whether you prefer a cozy one-bedroom or spacious three-bedroom layout. Seamlessly manage your living experience—access your resident portal to pay rent, schedule maintenance, and unlock a vibrant community lifestyle tailored just for you!",
  "property_reviews_blurb": "At 73TwentyFive in North Little Rock, our residents rave about the beautifully updated apartments and tranquil surroundings. One happy resident shares, \"We absolutely love it here!\" With clean grounds and a community-focused staff, find out why our neighborhood feels like home. See what our residents have to say about living at our community!",
  "property_created_at": "1752257093045",
  "property_scheduletour_blurb": "At 73TwentyFive in North Little Rock, AR, you'll find thoughtfully designed one, two, and three-bedroom apartments that perfectly suit your lifestyle. Experience the vibrant community and beautiful surroundings. Schedule your tour today, and hear firsthand why our residents love calling 73TwentyFive home!",
  "property_thankyou_blurb": "Thank you for reaching out to 73TwentyFive in North Little Rock, AR! Our inviting one, two, and three-bedroom floor plans await your discovery. Each home offers unique charm and comfort. A dedicated team member will connect with you soon to help find your perfect fit. Stay tuned!",
  "property_virtualtours_blurb": "<p>At 73TwentyFive, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your <a href=\"/floor-plans/\">new apartment home</a> & the <a href=\"/amenities/\">exceptional amenities</a> that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. 73TwentyFive",
  "property_seo_title_home": "73TwentyFive | Apartments in North Little Rock, AR",
  "property_seo_description_home": "Welcome to 73TwentyFive, where your ideal living space awaits in North Little Rock, AR. Choose from thoughtfully designed one, two, or three-bedroom apartments featuring modern upgrades, spacious floor plans, and two sparkling pools for relaxation. Enjoy top-notch amenities like 24/7 fitness facilities, a bark park for your furry friends, and convenient on-site laundry options. With ample parking and a dedicated courtesy officer, peace of mind is just a part of life here. Uncover a vibrant community lifestyle and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in North Little Rock, AR",
  "property_seo_description_floorplans": "Elevate your lifestyle at 73TwentyFive in North Little Rock, AR, where modern living meets comfort. From cozy one-bedroom nooks to spacious three-bedroom retreats, our thoughtfully designed floor plans cater to all your needs. Ready to make the move? Browse our available apartment homes to find the perfect fit for your unique lifestyle!",
  "property_seo_title_amenities": "Amenities | North Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at 73TwentyFive in North Little Rock, AR, where comfort meets convenience. Choose from stylish one, two, and three-bedroom apartments, fully equipped with upgraded appliances and flooring. Enjoy a wealth of amenities, including 24-hour access to our modern fitness center, two sparkling pools, and a dedicated Bark Park for your furry friends. With ample parking, emergency maintenance, and a supportive community staff, you'll feel right at home. Take the first step towards exceptional living—your perfect apartment awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in North Little Rock, AR",
  "property_seo_description_gallery": "\"Imagine your life at 73TwentyFive in North Little Rock, AR! Our stunning photo gallery showcases spacious one, two, and three-bedroom floor plans designed with upgraded appliances and flooring. Enjoy exceptional amenities, including two sparkling pools, a state-of-the-art 24-hour fitness center, and a playful Bark Park. Your comfort and convenience are our priority with ample parking, 24/7 availability, and a dedicated courtesy officer ensuring peace of mind. Dive into a vibrant living experience where luxury meets lifestyle! Picture yourself living here today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | 73TwentyFive Apartments",
  "property_seo_description_virtualtours": "Step inside the charm of 73TwentyFive in North Little Rock, AR, where modern living meets exceptional comfort. With thoughtfully designed one, two, and three-bedroom floor plans, our apartments invite you to envision your ideal lifestyle. Immerse yourself in a virtual tour of our vibrant community—your future home awaits! Don't miss your chance to see what makes us unique.",
  "property_seo_title_interactivemap": "Interactive Map | 73TwentyFive Apartments",
  "property_seo_description_interactivemap": "\"Find your perfect oasis at 73TwentyFive in North Little Rock, AR! With stylish one, two, and three-bedroom floor plans, upscale amenities like two sparkling pools, a 24-hour fitness center, and a bark park, your dream living space is just a click away. Navigate our interactive community map to explore available apartments, pricing, and make 73TwentyFive your new home today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Little Rock, AR",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of North Little Rock surrounding 73TwentyFive! Our apartment community offers a range of one, two, and three-bedroom floor plans, perfectly suited to any lifestyle. Dive into local favorites, scenic parks, and cultural hotspots just steps away. See what makes our neighborhood a delightful place to call home!",
  "property_seo_title_contact": "Contact Us | 73TwentyFive",
  "property_seo_description_contact": "Looking to elevate your living experience in North Little Rock? At 73TwentyFive, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments designed for comfort and style. Whether you’re seeking cozy solitude or room for a growing family, we have the perfect space for you. Have questions? Our friendly leasing team is just a message away—contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in North Little Rock, AR",
  "property_seo_description_faqs": "\"At 73TwentyFive in North Little Rock, AR, your comfort is our priority! With spacious one, two, and three-bedroom floor plans, enjoy premium amenities like two sparkling pools, a state-of-the-art 24-hour fitness center, and a dedicated bark park. Our community ensures convenience with ample parking, 24/7 availability, and quick emergency maintenance. Got questions? Our FAQs page is your go-to resource for everything you need to know about your future home.\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Little Rock, AR",
  "property_seo_description_reviews": "\"Uncover the vibrant life at 73TwentyFive in North Little Rock, AR. With an array of thoughtfully designed floor plans—including one, two, and three-bedroom options—this community offers spacious living infused with modern amenities. Enjoy two sparkling pools, a 24-hour fitness center, and a welcoming bark park, all while benefiting from 24/7 support and emergency maintenance. Curious about the experience here? Check out our resident reviews and see why 73TwentyFive is the perfect place to call home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in North Little Rock, AR",
  "property_seo_description_applynow": "\"Step into luxury at 73TwentyFive in North Little Rock, AR, where modern living meets incredible amenities! Choose from our spacious one, two, and three-bedroom floor plans, complete with upgraded appliances and flooring. With two sparkling pools, a 24-hour fitness center, and a welcoming bark park, there’s something for everyone here. Benefit from ample parking, on-site 24/7 emergency maintenance, and convenient clothes care options. Your perfect home is just a click away. Apply now and start your journey to effortless living!\"",
  "property_seo_title_residentaccess": "Resident Access | 73TwentyFive",
  "property_seo_description_residentaccess": "Unlock the convenience of 73TwentyFive in North Little Rock! Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and a seamless living experience—all at your fingertips. Your community, your way!",
  "property_seo_title_referafriend": "Refer A Friend | 73TwentyFive",
  "property_seo_description_referafriend": "Help your friends find their perfect home at 73TwentyFive in North Little Rock, AR! With a vibrant community and a welcoming atmosphere, great friends are just a referral away. Bring your besties into the fold and enjoy the joy of living in a place that feels like family! ",
  "property_seo_title_scheduletour": "Schedule a Tour | 73TwentyFive",
  "property_seo_description_scheduletour": "\"Step into a new way of living at 73TwentyFive in North Little Rock, AR. Our vibrant community awaits, blending modern amenities with cozy charm. Ready to find your perfect home? Schedule a tour today and see all we have to offer!\"",
  "property_seo_title_privacy": "Privacy Policy | 73TwentyFive",
  "property_seo_description_privacy": "At 73TwentyFive in North Little Rock, AR, we prioritize your privacy and peace of mind. Our comprehensive privacy policy outlines how we safeguard your personal information while you enjoy a vibrant apartment living experience. Curious about your data rights? Dive into our commitment to transparency and security - view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | 73TwentyFive",
  "property_seo_description_accessibility": "\"At 73TwentyFive in North Little Rock, AR, we champion digital inclusion for all. Our accessibility statement reflects our commitment to ensuring every resident and visitor enjoys a seamless online experience. Join a community where everyone belongs.\"",
  "property_seo_title_sitemap": "Sitemap | 73TwentyFive",
  "property_seo_description_sitemap": "\"Uncover the vibrant tapestry of 73TwentyFive in North Little Rock, AR. Navigate our website sitemap to find your ideal apartment, stylish amenities, and community highlights that redefine modern living. Let your journey begin!\"",
  "property_seo_title_thankyou": "Thank You | 73TwentyFive",
  "property_seo_description_thankyou": "\"Thank you for reaching out to 73TwentyFive in North Little Rock! Your inquiry is in great hands—our dedicated team will connect with you soon to guide you towards your ideal living experience in our vibrant community.\"",
  "property_seo_title_pets": "Pet Policy | Apartments in North Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293614861",
  "amenities": [
    {
      "id": "ec_c6ce98b9c0b25e363cfec41e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3024403f932c09aacfac0ee1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c27bb7789463af4a96c4b04d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1185ea1464a5e31d4a041d3f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4b4673eeef3c02ae7410b88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_113e86da9c7b63a3c7055723",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa1b09d0d4d46107578b6b7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b38bd87f6b3e3a8282ca6d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "2 Resort Style Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_308648999da8d7b4e35e3ead",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Luxury Apartments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1aa9e05bbe01f261027d4888",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea011aff848087307db609d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Modern Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44bb4e20a6d2aac025fb4846",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d05fb5f059fbd2c54bd9efbc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f951c73893dae9a2bffa51b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "All New Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11eb3eff2050e86b40892800",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Carpet and Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fa9f756c26e10d1dd5d0117",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2c5aa690a2b90c5123e87f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Hardware Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7702dee73f9d1e0067300e10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Lighting Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8cd4dde4a75b9813ea4ac2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Two‑tone Paint",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb38f65720cbe2ac69a2f10e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "external_id": "false",
      "title": "New Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6c37450d-b139-4778-a404-0b49d3fc05de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-cec0-773b-be5d-51aba7f966f3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fa489-cec0-773b-be5d-51aba7f966f3",
        "storage_key": "property/6737460151191765/019fa489-cec0-773b-be5d-51aba7f966f3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and surrounded by the beautiful apartment community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2cd094bf-e215-44a1-9304-62eeda94bc9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-8f2b-729c-b753-f9683d6e2517.webp",
      "image_media": {
        "alt_text": "Lounge area with comfortable seating, a TV, and a bar.",
        "public_id": "019e1e2f-8f2b-729c-b753-f9683d6e2517",
        "storage_key": "property/6737460151191765/019e1e2f-8f2b-729c-b753-f9683d6e2517.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Lounge area with comfortable seating, a TV, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1ebf27d-cf23-429c-9e57-6e6f7b2d817a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-228e-730a-b34e-10b52b5bc6ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances including a refrigerator, oven, microwave, and dishwasher.",
        "public_id": "019e1e2f-228e-730a-b34e-10b52b5bc6ce",
        "storage_key": "property/6737460151191765/019e1e2f-228e-730a-b34e-10b52b5bc6ce.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen, featuring sleek white cabinetry complemented by elegant granite countertops. Fully equipped with modern stainless steel appliances for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances including a refrigerator, oven, microwave, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_977562ba-72a3-46eb-839c-84079ef39f37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-77a7-769c-998f-c37116c40969.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, white linens, a ceiling fan, and a dresser with decorative items.",
        "public_id": "019e8523-77a7-769c-998f-c37116c40969",
        "storage_key": "property/6737460151191765/019e8523-77a7-769c-998f-c37116c40969.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush king-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, white linens, a ceiling fan, and a dresser with decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56309efd-fba5-45c2-9c02-9b076febd182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1913-770e-8255-b9c757f2c9fb.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with wood-style floors and a sliding glass door.",
        "public_id": "019e1e2f-1913-770e-8255-b9c757f2c9fb",
        "storage_key": "property/6737460151191765/019e1e2f-1913-770e-8255-b9c757f2c9fb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and bright living room with modern wood-style flooring and large windows, perfect for creating your own personalized living space.",
      "link": "",
      "alt_text": "Empty apartment living room with wood-style floors and a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_721a8274-4417-4388-bfad-956136d602e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-cecf-716b-9f4e-d854a323f3de.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fa489-cecf-716b-9f4e-d854a323f3de",
        "storage_key": "property/6737460151191765/019fa489-cecf-716b-9f4e-d854a323f3de.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "View of a stylish kitchen featuring dark wood cabinets, elegant granite countertops, a stainless steel dishwasher, and a convenient breakfast bar overlooking the dining area.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85f240ff-2d12-4995-b839-5da583751210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ca9e-7419-9599-a0a3a4c0a23f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019fa489-ca9e-7419-9599-a0a3a4c0a23f",
        "storage_key": "property/6737460151191765/019fa489-ca9e-7419-9599-a0a3a4c0a23f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A contemporary kitchen featuring dark wood cabinetry, sleek granite countertops, a full suite of stainless steel appliances including a refrigerator, microwave, and dishwasher, and a convenient double-basin sink.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b1310b7-dfd0-456d-8830-411d2568e86f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ce66-71ee-a870-918b28b0d3a7.webp",
      "image_media": {
        "alt_text": "Community lounge area with a bar, seating, and a dining table.",
        "public_id": "019fa489-ce66-71ee-a870-918b28b0d3a7",
        "storage_key": "property/6737460151191765/019fa489-ce66-71ee-a870-918b28b0d3a7.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Gather in our stylish community lounge, featuring a full-service coffee bar, comfortable seating, and a dining area perfect for socializing.",
      "link": "",
      "alt_text": "Community lounge area with a bar, seating, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5927d400-3f89-46e2-9a90-a0a1262fd3b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-95cc-705c-80c6-403d03bc85e2.webp",
      "image_media": {
        "alt_text": "Spin bikes and exercise equipment in a modern fitness center.",
        "public_id": "019e1e2f-95cc-705c-80c6-403d03bc85e2",
        "storage_key": "property/6737460151191765/019e1e2f-95cc-705c-80c6-403d03bc85e2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights for your workout needs.",
      "link": "",
      "alt_text": "Spin bikes and exercise equipment in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0a2c8e5-15eb-48f3-ba7b-1eaf392977b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-e149-714e-b3c6-f380f2c3ec32.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and covered seating area.",
        "public_id": "019e8523-e149-714e-b3c6-f380f2c3ec32",
        "storage_key": "property/6737460151191765/019e8523-e149-714e-b3c6-f380f2c3ec32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and a shaded seating area for ultimate relaxation.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and covered seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23158341-76da-46c6-92b9-6cc715cf41d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-e028-76c8-ac33-a852b4458432.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019e8523-e028-76c8-ac33-a852b4458432",
        "storage_key": "property/6737460151191765/019e8523-e028-76c8-ac33-a852b4458432.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, featuring comfortable lounge chairs and shaded seating areas. The perfect spot to unwind and enjoy the sunshine.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57184f7a-68d2-44d7-9fee-8c8838de2adb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-77e9-725a-8d2f-2522400a4dc6.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, glass coffee table, and entertainment center with TV. A glimpse of the bedroom is visible through an open doorway.",
        "public_id": "019e8523-77e9-725a-8d2f-2522400a4dc6",
        "storage_key": "property/6737460151191765/019e8523-77e9-725a-8d2f-2522400a4dc6.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed living space, complete with a plush sectional sofa, modern entertainment center, and ample natural light. The adjoining bedroom offers a serene retreat.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, glass coffee table, and entertainment center with TV. A glimpse of the bedroom is visible through an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e8db996-a1b6-415c-bca4-c77135c77b2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-ee25-75d8-9e58-0e64ec612350.webp",
      "image_media": {
        "alt_text": "Reception area with two light wood desks, artwork, and a coffee station with a decorative mirror.",
        "public_id": "019e8523-ee25-75d8-9e58-0e64ec612350",
        "storage_key": "property/6737460151191765/019e8523-ee25-75d8-9e58-0e64ec612350.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome guests at the beautifully designed reception area, featuring sleek light wood desks, elegant artwork, and a convenient coffee station.",
      "link": "",
      "alt_text": "Reception area with two light wood desks, artwork, and a coffee station with a decorative mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7c3e150-afdb-4fac-ab9d-70181b5c4793",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-e095-77f8-b80c-32a627f4dc89.webp",
      "image_media": {
        "alt_text": "Open concept common area with a kitchen island, bar seating, and a dining table.",
        "public_id": "019e8523-e095-77f8-b80c-32a627f4dc89",
        "storage_key": "property/6737460151191765/019e8523-e095-77f8-b80c-32a627f4dc89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the spacious and inviting common areas, perfect for entertaining or relaxing. Featuring a modern kitchen island with bar seating and a stylish dining area.",
      "link": "",
      "alt_text": "Open concept common area with a kitchen island, bar seating, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ecfdae3a-1b03-4b55-b080-2f6dfbdad3e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-e030-7412-9f9c-4a50f97ff451.webp",
      "image_media": {
        "alt_text": "Brick building exterior with covered entryway and signs for future resident parking.",
        "public_id": "019e8523-e030-7412-9f9c-4a50f97ff451",
        "storage_key": "property/6737460151191765/019e8523-e030-7412-9f9c-4a50f97ff451.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to our community's leasing office. This building features a brick exterior, a covered entryway, and convenient parking for future residents.",
      "link": "",
      "alt_text": "Brick building exterior with covered entryway and signs for future resident parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2ed6ddb-6b10-40f8-903b-eba47e03af25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-dd79-747b-84c2-d2fa28b97e5c.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines including treadmills and ellipticals.",
        "public_id": "019e8523-dd79-747b-84c2-d2fa28b97e5c",
        "storage_key": "property/6737460151191765/019e8523-dd79-747b-84c2-d2fa28b97e5c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines to help you reach your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with cardio machines including treadmills and ellipticals.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94bc3048-00eb-47bd-99e0-c55a8a188c23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-d7af-7239-a5eb-692d0032e2a7.webp",
      "image_media": {
        "alt_text": "Fitness studio with spin bikes and mirrored wall",
        "public_id": "019e8523-d7af-7239-a5eb-692d0032e2a7",
        "storage_key": "property/6737460151191765/019e8523-d7af-7239-a5eb-692d0032e2a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Bright and airy fitness studio featuring spin bikes, a mirrored wall, and ample space for classes and workouts.",
      "link": "",
      "alt_text": "Fitness studio with spin bikes and mirrored wall",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_791c091c-2dfb-4db2-bb5f-63ee7542d226",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b0f8-7009-aea8-2e2c8848176f.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and neutral gray walls.",
        "public_id": "019e8523-b0f8-7009-aea8-2e2c8848176f",
        "storage_key": "property/6737460151191765/019e8523-b0f8-7009-aea8-2e2c8848176f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with soft gray walls, plush carpeting, and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and neutral gray walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c8613f2-72c0-4143-b63c-faf81507aa98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b0ce-70f1-ba3f-a2bee54eec2a.webp",
      "image_media": {
        "alt_text": "Bedroom with neutral carpet, ceiling fan, and large window with blinds.",
        "public_id": "019e8523-b0ce-70f1-ba3f-a2bee54eec2a",
        "storage_key": "property/6737460151191765/019e8523-b0ce-70f1-ba3f-a2bee54eec2a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, neutral carpeting, and a large window that allows natural light to fill the room.",
      "link": "",
      "alt_text": "Bedroom with neutral carpet, ceiling fan, and large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ceb07a57-5f05-4da8-9d9a-41fddc9eaf24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b0e9-75bf-b195-767978043031.webp",
      "image_media": {
        "alt_text": "Empty dining room with wood-look flooring and chandelier.",
        "public_id": "019e8523-b0e9-75bf-b195-767978043031",
        "storage_key": "property/6737460151191765/019e8523-b0e9-75bf-b195-767978043031.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy dining room featuring elegant wood-look flooring and a modern chandelier, perfect for intimate meals or entertaining guests.",
      "link": "",
      "alt_text": "Empty dining room with wood-look flooring and chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6280e515-6144-4d2e-971e-db4498faebe3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-a1ff-779d-b8c1-63d65ab9ff7c.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and surrounding landscape.",
        "public_id": "019e8523-a1ff-779d-b8c1-63d65ab9ff7c",
        "storage_key": "property/6737460151191765/019e8523-a1ff-779d-b8c1-63d65ab9ff7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial perspective showcases the apartment complex's buildings, parking areas, and manicured grounds, offering a comprehensive view of the community's layout and environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_527b1db3-7a96-4c67-8e95-4f7a75b388e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b068-7752-b7af-9e58763468fb.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a swimming pool with a lake in the background.",
        "public_id": "019e8523-b068-7752-b7af-9e58763468fb",
        "storage_key": "property/6737460151191765/019e8523-b068-7752-b7af-9e58763468fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living at our apartment community, featuring a sparkling swimming pool and scenic lake views. Enjoy a vibrant lifestyle with ample amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a swimming pool with a lake in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1295d6b3-ffba-4c6a-843f-bc70eb837ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b08d-778f-8803-ac98777071d5.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with wood-look flooring and a ceiling fan.",
        "public_id": "019e8523-b08d-778f-8803-ac98777071d5",
        "storage_key": "property/6737460151191765/019e8523-b08d-778f-8803-ac98777071d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen, perfect for entertaining. Features wood-look flooring and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Living room and kitchen area with wood-look flooring and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_af00d79b-90d4-40b8-96f6-4a2b8cf58f92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-ffc6-714e-b900-b1bd0a803159.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e1e2e-ffc6-714e-b900-b1bd0a803159",
        "storage_key": "property/6737460151191765/019e1e2e-ffc6-714e-b900-b1bd0a803159.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a70b1810-3d35-46d3-b188-40b398794e7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-aa05-76d3-bafd-e45a08295b2b.webp",
      "image_media": {
        "alt_text": "Aerial view of apartments with a swimming pool and a river in the background.",
        "public_id": "019e8523-aa05-76d3-bafd-e45a08295b2b",
        "storage_key": "property/6737460151191765/019e8523-aa05-76d3-bafd-e45a08295b2b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment complex overlooking a serene river, featuring a sparkling swimming pool and ample parking. Enjoy comfortable living in a picturesque setting.",
      "link": "",
      "alt_text": "Aerial view of apartments with a swimming pool and a river in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53b5b8e4-6e19-41d0-862a-e88a0ce7b63d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-aaf1-726d-a7dc-22e16f8ca984.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a door.",
        "public_id": "019e8523-aaf1-726d-a7dc-22e16f8ca984",
        "storage_key": "property/6737460151191765/019e8523-aaf1-726d-a7dc-22e16f8ca984.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinets, granite countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec3f19cb-7311-421c-8a86-d3b5694314f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-cf16-729d-93e0-9a21ef785cf5.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa, coffee table, and large abstract art.",
        "public_id": "019fa489-cf16-729d-93e0-9a21ef785cf5",
        "storage_key": "property/6737460151191765/019fa489-cf16-729d-93e0-9a21ef785cf5.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable blue sofa, a modern coffee table, and striking abstract wall art, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with blue sofa, coffee table, and large abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de0211be-cb62-44b4-9fa1-043e06ab147f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-a26c-7428-9e43-a4b0a0336fba.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a lake in the background.",
        "public_id": "019e8523-a26c-7428-9e43-a4b0a0336fba",
        "storage_key": "property/6737460151191765/019e8523-a26c-7428-9e43-a4b0a0336fba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious apartment buildings with a serene lake view, offering a peaceful living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a lake in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9642a8b4-8409-404e-a830-6f7f4668369a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-c5b9-7651-8c0e-e1fd7652e43e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, shower, toilet, and a vanity with a granite countertop and a stainless steel faucet.",
        "public_id": "019e8523-c5b9-7651-8c0e-e1fd7652e43e",
        "storage_key": "property/6737460151191765/019e8523-c5b9-7651-8c0e-e1fd7652e43e.webp",
        "width": 3072,
        "height": 1816
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed bathroom, featuring a pristine white tub and shower, a modern vanity with a granite countertop, and sleek fixtures. Perfect for relaxing after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, shower, toilet, and a vanity with a granite countertop and a stainless steel faucet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58329a9a-9915-49c5-822c-46de174ce480",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-b0af-714b-a08e-8d18fbd86d79.webp",
      "image_media": {
        "alt_text": "Kitchen featuring granite countertops, white cabinets, stainless steel dishwasher, and refrigerator.",
        "public_id": "019e8523-b0af-714b-a08e-8d18fbd86d79",
        "storage_key": "property/6737460151191765/019e8523-b0af-714b-a08e-8d18fbd86d79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern kitchen with granite countertops and white cabinetry. Includes a stainless steel dishwasher, refrigerator, and an electric stove.",
      "link": "",
      "alt_text": "Kitchen featuring granite countertops, white cabinets, stainless steel dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a475b24-9d1a-4b5a-9b85-0f348e9a5394",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-896f-711c-ae8e-8d30b6d998f3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with pool and lake in background.",
        "public_id": "019e8523-896f-711c-ae8e-8d30b6d998f3",
        "storage_key": "property/6737460151191765/019e8523-896f-711c-ae8e-8d30b6d998f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious apartment community offering a refreshing pool and scenic lake views.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with pool and lake in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c69fe9d-8647-469d-aea6-abb18d51a132",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-77b7-76da-9831-5f7967498f39.webp",
      "image_media": {
        "alt_text": "Living room with a blue sofa, coffee table, and view into bedroom.",
        "public_id": "019e8523-77b7-76da-9831-5f7967498f39",
        "storage_key": "property/6737460151191765/019e8523-77b7-76da-9831-5f7967498f39.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Spacious living area with modern furnishings and a king-size bedroom visible through an open doorway.",
      "link": "",
      "alt_text": "Living room with a blue sofa, coffee table, and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e467b9cd-cb8a-4f3e-b4e5-4e6d8f58d752",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-7823-768c-85d9-079d43b5231b.webp",
      "image_media": {
        "alt_text": "Living room with blue couch, coffee table, dresser, and abstract art.",
        "public_id": "019e8523-7823-768c-85d9-079d43b5231b",
        "storage_key": "property/6737460151191765/019e8523-7823-768c-85d9-079d43b5231b.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a plush blue sofa, a modern coffee table, and decorative wall art. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with blue couch, coffee table, dresser, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ace27a37-619d-4c98-b24f-b4765215678f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-72be-7717-ad04-e67ac49b4dd1.webp",
      "image_media": {
        "alt_text": "Dining area with oval table, four chairs, and abstract wall art.",
        "public_id": "019e8523-72be-7717-ad04-e67ac49b4dd1",
        "storage_key": "property/6737460151191765/019e8523-72be-7717-ad04-e67ac49b4dd1.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring an oval table, comfortable seating, and modern abstract art, creating an inviting atmosphere for meals.",
      "link": "",
      "alt_text": "Dining area with oval table, four chairs, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d139630f-76ef-49bc-9d11-83d42e50ebfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-7006-75d9-a0c8-efa105369ed2.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "019e8523-7006-75d9-a0c8-efa105369ed2",
        "storage_key": "property/6737460151191765/019e8523-7006-75d9-a0c8-efa105369ed2.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3c0758a-b7db-47fc-b43b-6748c1d4099f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-670f-7129-ae41-1f59371f8689.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area surrounded by apartment buildings.",
        "public_id": "019e8523-670f-7129-ae41-1f59371f8689",
        "storage_key": "property/6737460151191765/019e8523-670f-7129-ae41-1f59371f8689.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool at our community. Enjoy the sun and unwind on the comfortable lounge chairs.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89c26cdd-afc8-4b3d-ac0e-e4b0becfa074",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-6728-737c-be07-688c4c24eccf.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, white sink, and modern light fixtures.",
        "public_id": "019e8523-6728-737c-be07-688c4c24eccf",
        "storage_key": "property/6737460151191765/019e8523-6728-737c-be07-688c4c24eccf.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A spacious bathroom featuring a vanity with a granite countertop, a white undermount sink, and a well-lit mirror area. The room has a clean and modern aesthetic.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, white sink, and modern light fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ff8d9ee-9c6b-42d7-b053-ba9ae659498f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-4c86-767e-a82a-135601d02efa.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, navy blue tufted headboard, and patterned curtains.",
        "public_id": "019e8523-4c86-767e-a82a-135601d02efa",
        "storage_key": "property/6737460151191765/019e8523-4c86-767e-a82a-135601d02efa.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting bedroom, featuring a plush queen-size bed with a stylish navy blue headboard and elegant patterned curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, navy blue tufted headboard, and patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab38edfb-240e-40d0-96ee-3d11035de478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-6753-7053-a686-f497815adede.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and window.",
        "public_id": "019e8523-6753-7053-a686-f497815adede",
        "storage_key": "property/6737460151191765/019e8523-6753-7053-a686-f497815adede.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, featuring a plush king-sized bed, ample dresser storage, and large windows for natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f93f8368-350f-4fba-8266-de0afd32fc32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-6730-7209-a484-4a935e4b6907.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a closet next to a dining area with a table and chairs.",
        "public_id": "019e8523-6730-7209-a484-4a935e4b6907",
        "storage_key": "property/6737460151191765/019e8523-6730-7209-a484-4a935e4b6907.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer adjacent to a stylish dining area, perfect for everyday living.",
      "link": "",
      "alt_text": "Washer and dryer in a closet next to a dining area with a table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f87674b-24f4-42b8-8613-4b0ab72d96ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-639b-7477-9c2d-e99a8caaa1b4.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019e8523-639b-7477-9c2d-e99a8caaa1b4",
        "storage_key": "property/6737460151191765/019e8523-639b-7477-9c2d-e99a8caaa1b4.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a bathtub with a blue and white striped shower curtain, a toilet, and a vanity with a granite countertop and wood cabinets.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_449c5dbf-d774-455a-bb54-aab0e63f7de4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-cf1d-72fe-b28b-db33ea88765f.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, tufted headboard, and ceiling fan.",
        "public_id": "019fa489-cf1d-72fe-b28b-db33ea88765f",
        "storage_key": "property/6737460151191765/019fa489-cf1d-72fe-b28b-db33ea88765f.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush king-size bed, elegant tufted headboard, and a convenient ceiling fan for your comfort.",
      "link": "",
      "alt_text": "Luxurious bedroom with a king-size bed, tufted headboard, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f621588-eef8-486d-bad5-06fd10cb7deb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-63da-76ba-aa9d-68b42cb86fc8.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and artwork.",
        "public_id": "019e8523-63da-76ba-aa9d-68b42cb86fc8",
        "storage_key": "property/6737460151191765/019e8523-63da-76ba-aa9d-68b42cb86fc8.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable bed, a stylish dresser with decorative mirrors, and a large abstract artwork on the wall.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df360de5-eefb-4614-b117-d9f7e317b49d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ca8f-7117-ac47-ca411671bd63.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a brick building.",
        "public_id": "019fa489-ca8f-7117-ac47-ca411671bd63",
        "storage_key": "property/6737460151191765/019fa489-ca8f-7117-ac47-ca411671bd63.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d80a9b0a-cf78-468d-b943-ae7588dd6b86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-6186-77ce-bbfa-b07026a41c1b.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019e8523-6186-77ce-bbfa-b07026a41c1b",
        "storage_key": "property/6737460151191765/019e8523-6186-77ce-bbfa-b07026a41c1b.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating. Enjoy the perfect place to cool off and soak up the sun.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dec8ce6-bb4b-4952-8e94-427fd155637b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-5d8a-74dd-b59b-4ee1b38525e4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables, adjacent to a brick clubhouse.",
        "public_id": "019e8523-5d8a-74dd-b59b-4ee1b38525e4",
        "storage_key": "property/6737460151191765/019e8523-5d8a-74dd-b59b-4ee1b38525e4.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and seating areas, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and tables, adjacent to a brick clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5fdd2be-6d1b-491a-a5db-4ee971529db2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-9299-77da-abeb-8209e0e1c275.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with multiple buildings, parking lots, and a pool.",
        "public_id": "019e8523-9299-77da-abeb-8209e0e1c275",
        "storage_key": "property/6737460151191765/019e8523-9299-77da-abeb-8209e0e1c275.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover your new home at this expansive multifamily property, featuring a sparkling outdoor pool and ample parking, set against a backdrop of lush greenery and scenic hills.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with multiple buildings, parking lots, and a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd1b8021-383a-4d3e-a7d1-30cf73bb6341",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-63b7-71ac-8fab-5a800d4aaf3b.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with red brick and white siding, balconies, and parking lot.",
        "public_id": "019e8523-63b7-71ac-8fab-5a800d4aaf3b",
        "storage_key": "property/6737460151191765/019e8523-63b7-71ac-8fab-5a800d4aaf3b.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Stunning exterior view of the apartment complex, showcasing its modern design with red brick and white siding. Ample parking available.",
      "link": "",
      "alt_text": "Exterior of apartment building with red brick and white siding, balconies, and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_953f6b0f-d4e2-48ba-9ec9-23ff0278d521",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-63db-734a-8f0c-2bafcbb8a77d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a large parking lot and lush landscaping.",
        "public_id": "019e8523-63db-734a-8f0c-2bafcbb8a77d",
        "storage_key": "property/6737460151191765/019e8523-63db-734a-8f0c-2bafcbb8a77d.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Spacious apartment community featuring ample parking, well-maintained grounds, and attractive building exteriors, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a large parking lot and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89524f43-dc63-411c-8223-91197e2b4f39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-463e-752b-abd5-9bcfca362932.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and entertainment center.",
        "public_id": "019e8523-463e-752b-abd5-9bcfca362932",
        "storage_key": "property/6737460151191765/019e8523-463e-752b-abd5-9bcfca362932.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious living area, featuring a plush sectional sofa and a modern entertainment center.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5154f26b-9457-4708-abcb-fe72758c3959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1314-72af-aeb0-bcaaa1594b9c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e1e2f-1314-72af-aeb0-bcaaa1594b9c",
        "storage_key": "property/6737460151191765/019e1e2f-1314-72af-aeb0-bcaaa1594b9c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring dark wood cabinetry, sleek stainless steel appliances including a microwave and refrigerator, complemented by elegant granite countertops and modern fixtures.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3768aa9a-99b9-4051-97aa-178f9d4530b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-4796-7135-848d-37c2d4b9dd7d.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a toilet, shower, and bathtub.",
        "public_id": "019e8523-4796-7135-848d-37c2d4b9dd7d",
        "storage_key": "property/6737460151191765/019e8523-4796-7135-848d-37c2d4b9dd7d.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a toilet, a shower-tub combination with a decorative shower curtain, and a granite-topped vanity.",
      "link": "",
      "alt_text": "Clean bathroom with a toilet, shower, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a9199ed-d218-4418-84df-f53a8355c6b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e8523-467c-727e-ae43-a9374e7cbde8.webp",
      "image_media": {
        "alt_text": "Cozy seating area with two armchairs, a small table with a book and coffee cup, and decorative mirrors.",
        "public_id": "019e8523-467c-727e-ae43-a9374e7cbde8",
        "storage_key": "property/6737460151191765/019e8523-467c-727e-ae43-a9374e7cbde8.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "Relax and unwind in our comfortable seating area, featuring elegant decor and a serene ambiance.",
      "link": "",
      "alt_text": "Cozy seating area with two armchairs, a small table with a book and coffee cup, and decorative mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6cd5d20c-528d-44dd-9451-950650618d6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-959e-73e3-b6a8-ef5cbd3f1342.webp",
      "image_media": {
        "alt_text": "Spin bikes in a well-lit gym with mirrors and orange accent walls.",
        "public_id": "019e1e2f-959e-73e3-b6a8-ef5cbd3f1342",
        "storage_key": "property/6737460151191765/019e1e2f-959e-73e3-b6a8-ef5cbd3f1342.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Get your workout in at our fully equipped fitness center, featuring cardio machines and ample space for your training routine.",
      "link": "",
      "alt_text": "Spin bikes in a well-lit gym with mirrors and orange accent walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_959c4fdd-2d84-49ae-8cfa-4488e327b991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ceb1-729e-9871-53f71c9582d7.webp",
      "image_media": {
        "alt_text": "Curving swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fa489-ceb1-729e-9871-53f71c9582d7",
        "storage_key": "property/6737460151191765/019fa489-ceb1-729e-9871-53f71c9582d7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Curving swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1153e671-34d8-489f-9151-1085b8a71598",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-3220-70d2-bfb0-61ee932745d8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, blinds on window, and ceiling fan.",
        "public_id": "019e1e2f-3220-70d2-bfb0-61ee932745d8",
        "storage_key": "property/6737460151191765/019e1e2f-3220-70d2-bfb0-61ee932745d8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan for comfort, and large blinds on the window, creating a bright and inviting atmosphere.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, blinds on window, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58436b2f-160e-473a-8db4-2a1ddb1d4519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-8f2a-74ad-a50c-0a2b3b5e7ed0.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a bright, well-lit gym with large windows.",
        "public_id": "019e1e2f-8f2a-74ad-a50c-0a2b3b5e7ed0",
        "storage_key": "property/6737460151191765/019e1e2f-8f2a-74ad-a50c-0a2b3b5e7ed0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills and elliptical machines for your workout needs.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a bright, well-lit gym with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b6c79b6-5b0f-4f03-9bdd-cfb39ce21430",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ca8d-71fe-93c4-6eed5befa2af.webp",
      "image_media": {
        "alt_text": "A well-lit fitness center with treadmills, ellipticals, and free weights.",
        "public_id": "019fa489-ca8d-71fe-93c4-6eed5befa2af",
        "storage_key": "property/6737460151191765/019fa489-ca8d-71fe-93c4-6eed5befa2af.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "A well-lit fitness center with treadmills, ellipticals, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6a30432-e999-4f0c-b5c7-c40806978cfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019fa489-ca5e-7339-a193-d05f26e0af21.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines and mirrors",
        "public_id": "019fa489-ca5e-7339-a193-d05f26e0af21",
        "storage_key": "property/6737460151191765/019fa489-ca5e-7339-a193-d05f26e0af21.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a variety of weight machines and cardio equipment, perfect for maintaining your active lifestyle.",
      "link": "",
      "alt_text": "Fitness center with weight machines and mirrors",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21b9a2de-85c4-4d5a-92b9-e53308d8a58c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-8233-749c-b88c-c31be1889c55.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with a coffee bar, dining table, and seating.",
        "public_id": "019e1e2f-8233-749c-b88c-c31be1889c55",
        "storage_key": "property/6737460151191765/019e1e2f-8233-749c-b88c-c31be1889c55.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge, featuring a convenient coffee bar, a comfortable dining area, and ample seating for relaxation and socializing.",
      "link": "",
      "alt_text": "Modern community lounge area with a coffee bar, dining table, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7890d4aa-7eb1-4795-ac41-927e17ec2f0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-7ff9-771c-96c7-aa2d2936cfd0.webp",
      "image_media": {
        "alt_text": "Community lounge area with a TV, comfortable seating, and a dining table.",
        "public_id": "019e1e2f-7ff9-771c-96c7-aa2d2936cfd0",
        "storage_key": "property/6737460151191765/019e1e2f-7ff9-771c-96c7-aa2d2936cfd0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a modern entertainment area and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge area with a TV, comfortable seating, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ec992f7-5252-421d-9ee4-85f74b6c67ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-7fd5-70cb-a9f3-c977f45fa5d8.webp",
      "image_media": {
        "alt_text": "Empty living room with light blue walls and wood-look flooring, leading to a sliding glass door.",
        "public_id": "019e1e2f-7fd5-70cb-a9f3-c977f45fa5d8",
        "storage_key": "property/6737460151191765/019e1e2f-7fd5-70cb-a9f3-c977f45fa5d8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "An empty living space with pale blue walls, wood-look flooring, and a sliding glass door offering a view of the exterior.",
      "link": "",
      "alt_text": "Empty living room with light blue walls and wood-look flooring, leading to a sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9199fb53-8010-41f4-a3b9-e2270a4162eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-78c7-73de-8985-6a49dbf03d65.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and closet.",
        "public_id": "019e1e2f-78c7-73de-8985-6a49dbf03d65",
        "storage_key": "property/6737460151191765/019e1e2f-78c7-73de-8985-6a49dbf03d65.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with wood-style flooring and access to a private balcony. Features a sliding glass door and a convenient closet.",
      "link": "",
      "alt_text": "Empty living room with sliding glass door and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7aa56372-5b9f-4b29-8257-c824e23bc426",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-7698-70eb-9a8e-98f5ac0cc42f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, ceiling fan, and closet.",
        "public_id": "019e1e2f-7698-70eb-9a8e-98f5ac0cc42f",
        "storage_key": "property/6737460151191765/019e1e2f-7698-70eb-9a8e-98f5ac0cc42f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and ample closet space. An adjacent door leads to another room.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, ceiling fan, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e28f6847-13c5-4437-8077-4376c9d51da6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-5ca8-727b-b127-6c872320fd9e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, ceiling fan, and large window overlooking buildings.",
        "public_id": "019e1e2f-5ca8-727b-b127-6c872320fd9e",
        "storage_key": "property/6737460151191765/019e1e2f-5ca8-727b-b127-6c872320fd9e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a modern ceiling fan, and a large window that offers natural light and views of the surrounding community.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, ceiling fan, and large window overlooking buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_169b1c00-8966-4e52-93ac-7edf08bdfc2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-5c5f-76e1-b247-4a9ea1985dc5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a closed door.",
        "public_id": "019e1e2f-5c5f-76e1-b247-4a9ea1985dc5",
        "storage_key": "property/6737460151191765/019e1e2f-5c5f-76e1-b247-4a9ea1985dc5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This empty bedroom features neutral carpeting, a ceiling fan, and a white six-panel door.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a closed door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ddbe5cd-25f7-4bf7-9c70-59b5dafc3563",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-4491-76cc-8147-455a0de2dc39.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel dishwasher, and refrigerator.",
        "public_id": "019e1e2f-4491-76cc-8147-455a0de2dc39",
        "storage_key": "property/6737460151191765/019e1e2f-4491-76cc-8147-455a0de2dc39.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark cabinetry, sleek granite countertops, a double sink with a gooseneck faucet, a stainless steel dishwasher, and a stainless steel refrigerator.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, granite countertops, stainless steel dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98b0969f-6157-4702-9c7e-451737daa1d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-46db-76ec-9c87-69c68ed5bf81.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and ceiling fan.",
        "public_id": "019e1e2f-46db-76ec-9c87-69c68ed5bf81",
        "storage_key": "property/6737460151191765/019e1e2f-46db-76ec-9c87-69c68ed5bf81.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring plush carpeting and a modern ceiling fan for comfort and style.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b85ce7a9-945e-49a3-b4e1-8af95e122b7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-435f-7029-9fc3-3d57f54f9b4f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls, carpet, blinds, and a ceiling fan.",
        "public_id": "019e1e2f-435f-7029-9fc3-3d57f54f9b4f",
        "storage_key": "property/6737460151191765/019e1e2f-435f-7029-9fc3-3d57f54f9b4f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, neutral paint, and a ceiling fan, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls, carpet, blinds, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7a1e223-7802-415b-ab8e-d8c9aa91a78e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-3166-70b2-b34d-6af74f10bfa1.webp",
      "image_media": {
        "alt_text": "Washer and dryer inside a closet. A bathroom is visible through an open doorway to the left.",
        "public_id": "019e1e2f-3166-70b2-b34d-6af74f10bfa1",
        "storage_key": "property/6737460151191765/019e1e2f-3166-70b2-b34d-6af74f10bfa1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience, located inside a closet. A bathroom is accessible through a doorway on the left.",
      "link": "",
      "alt_text": "Washer and dryer inside a closet. A bathroom is visible through an open doorway to the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9280298d-69d7-4338-989e-48cb81c677fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-3800-70b2-aa40-a8f1fd350e78.webp",
      "image_media": {
        "alt_text": "View of a modern apartment kitchen and living room with wood-look flooring and white walls.",
        "public_id": "019e1e2f-3800-70b2-aa40-a8f1fd350e78",
        "storage_key": "property/6737460151191765/019e1e2f-3800-70b2-aa40-a8f1fd350e78.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into comfort with this apartment's spacious living area and sleek kitchen, featuring modern appliances and stylish finishes.",
      "link": "",
      "alt_text": "View of a modern apartment kitchen and living room with wood-look flooring and white walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cdc9353c-f6c8-4181-8142-8014c2045e64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-44f3-739f-8233-d8a3834c691a.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and vertical blinds.",
        "public_id": "019e1e2f-44f3-739f-8233-d8a3834c691a",
        "storage_key": "property/6737460151191765/019e1e2f-44f3-739f-8233-d8a3834c691a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with wood-style flooring and neutral walls, featuring a sliding glass door for ample natural light.",
      "link": "",
      "alt_text": "Empty living room with sliding glass door and vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac00ded4-f261-443b-ab7c-c42655bda8bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-37f7-7035-8d3f-5be44e817d5d.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with sliding glass door and wood-look flooring.",
        "public_id": "019e1e2f-37f7-7035-8d3f-5be44e817d5d",
        "storage_key": "property/6737460151191765/019e1e2f-37f7-7035-8d3f-5be44e817d5d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and bright empty apartment living room featuring modern wood-look flooring and a sliding glass door with vertical blinds, leading to a patio or balcony area. The neutral walls provide a versatile backdrop for any decor.",
      "link": "",
      "alt_text": "Empty apartment living room with sliding glass door and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d9eb5a8-64d9-4a69-b801-e2ea8ee3698e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-2f00-7788-91f7-b9a83d690af4.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment with a door, pass-through window to kitchen, and dining area with chandelier.",
        "public_id": "019e1e2f-2f00-7788-91f7-b9a83d690af4",
        "storage_key": "property/6737460151191765/019e1e2f-2f00-7788-91f7-b9a83d690af4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious apartment interior featuring a modern entryway, an open-concept living and dining area, and a glimpse into the kitchen.",
      "link": "",
      "alt_text": "Interior view of an apartment with a door, pass-through window to kitchen, and dining area with chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63cce408-e388-44e8-8c16-238730f36ecb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1c95-70c2-a427-62b42e1bb370.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and wood-look flooring.",
        "public_id": "019e1e2f-1c95-70c2-a427-62b42e1bb370",
        "storage_key": "property/6737460151191765/019e1e2f-1c95-70c2-a427-62b42e1bb370.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral walls, wood-look flooring, and a sliding glass door leading to an outdoor space.",
      "link": "",
      "alt_text": "Empty living room with sliding glass door and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36c6c7f9-7808-4819-bc7d-65abbe8bd82b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1b0a-7005-b4e5-6a77befd5b86.webp",
      "image_media": {
        "alt_text": "Kitchen sink with chrome faucet and granite countertops.",
        "public_id": "019e1e2f-1b0a-7005-b4e5-6a77befd5b86",
        "storage_key": "property/6737460151191765/019e1e2f-1b0a-7005-b4e5-6a77befd5b86.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy the modern convenience of a double-basin sink with a stylish chrome faucet, complemented by beautiful granite countertops.",
      "link": "",
      "alt_text": "Kitchen sink with chrome faucet and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_705709c5-d316-45b2-a58f-5e3335ae0546",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1c46-72bd-b213-86d66a39c8f7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen pass-through in an empty apartment.",
        "public_id": "019e1e2f-1c46-72bd-b213-86d66a39c8f7",
        "storage_key": "property/6737460151191765/019e1e2f-1c46-72bd-b213-86d66a39c8f7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this inviting living space with a pass-through to the modern kitchen. Enjoy the open feel and ample natural light.",
      "link": "",
      "alt_text": "Living room and kitchen pass-through in an empty apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d77cecf6-5a9b-4f2a-834c-34041f5a86e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-1b26-709d-ba77-d9c037c4514c.webp",
      "image_media": {
        "alt_text": "Closet with stacked washer and dryer",
        "public_id": "019e1e2f-1b26-709d-ba77-d9c037c4514c",
        "storage_key": "property/6737460151191765/019e1e2f-1b26-709d-ba77-d9c037c4514c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience. Located in a spacious closet.",
      "link": "",
      "alt_text": "Closet with stacked washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b998c107-ec5b-43fe-91d5-3962258dea4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-ff77-705f-8ca8-a742795e709e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, and granite countertops.",
        "public_id": "019e1e2e-ff77-705f-8ca8-a742795e709e",
        "storage_key": "property/6737460151191765/019e1e2e-ff77-705f-8ca8-a742795e709e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e438820e-bc07-44ac-8c97-b139f47bf44a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "MorningSide Bagels",
      "poi_type": "Restaurants",
      "poi_address": "10848 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "Laid-back cafe featuring bagels, sandwiches, pastries and espresso drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-a717-7558-89d7-9f560b8c7381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-a717-7558-89d7-9f560b8c7381",
        "storage_key": "property/6737460151191765/019e1e39-a717-7558-89d7-9f560b8c7381.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.ordermorningsidebagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9475996538554508772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morningside-bagels",
      "poi_latitude": "34.8246701",
      "poi_longitude": "-92.381405",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-753-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZztJ_ah0ocR5GVfVaWAgYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_f480b61a-d443-4330-b7fe-f28932c706b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Boudreauxs Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9811 Maumelle Blvd, Maumelle, AR 72113, USA",
      "poi_short_description": "Cajun & Creole cooking served in a casual, low-lit bar with dartboards & televised sports.",
      "poi_long_description": "Cajun & Creole cooking served in a casual, low-lit bar with dartboards & televised sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-a6b8-709e-bf3f-f6bcd82d6b32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-a6b8-709e-bf3f-f6bcd82d6b32",
        "storage_key": "property/6737460151191765/019e1e39-a6b8-709e-bf3f-f6bcd82d6b32.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.boudreauxs.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1502917443921864539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boudreauxs-grill--bar",
      "poi_latitude": "34.8226058",
      "poi_longitude": "-92.3702682",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-753-6860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-035a-771c-8b98-ae4e6477ac9d",
        "storage_key": "property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp30c0RWi0ocRW2ez03Nv2xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_d0a5e896-6cf3-4d20-a62c-296895bf8e7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Capeo | Italian",
      "poi_type": "Restaurants",
      "poi_address": "425 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Refined Italian menu with a long wine list presented in an intimate space with an open kitchen.",
      "poi_long_description": "Refined Italian menu with a long wine list presented in an intimate space with an open kitchen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-a62b-76f4-b92a-b5e892c91456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-a62b-76f4-b92a-b5e892c91456",
        "storage_key": "property/6737460151191765/019e1e39-a62b-76f4-b92a-b5e892c91456.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.capeo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349934928727282787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capeo--italian",
      "poi_latitude": "34.7579292",
      "poi_longitude": "-92.2678874",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-376-3463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6xP_YO80ocRY5QSAF6lnCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_86c8c08a-28a9-4837-8ab4-a6e3edbb9691",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Riverfront Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2 Riverfront Pl, North Little Rock, AR 72114, USA",
      "poi_short_description": "Seasoned slabs of prime beef cooked in an infrared broiler oven, plus a sizable wine list.",
      "poi_long_description": "Seasoned slabs of prime beef cooked in an infrared broiler oven, plus a sizable wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ac40-7069-9f20-fdce1bc65af6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ac40-7069-9f20-fdce1bc65af6",
        "storage_key": "property/6737460151191765/019e1e39-ac40-7069-9f20-fdce1bc65af6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.riverfront-steakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10999020570985421463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-steakhouse",
      "poi_latitude": "34.7545525",
      "poi_longitude": "-92.2705793",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-375-7825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9dMiXoK80ocRl9rMGu9epJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f6ad2f7e-c299-4507-bab4-1572fcee7b29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "DRAFT + TABLE",
      "poi_type": "Restaurants",
      "poi_address": "301 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Relaxed stop offering small plates, beer, and wine, plus an outdoor seating area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ab73-77b8-b045-0d41fb563c98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ab73-77b8-b045-0d41fb563c98",
        "storage_key": "property/6737460151191765/019e1e39-ab73-77b8-b045-0d41fb563c98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.draftandtable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5833141647898139730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "draft--table",
      "poi_latitude": "34.7562095",
      "poi_longitude": "-92.2679375",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-441-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtSyOupS90ocRUlyBZ2x781A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_eb5d43a3-0659-4794-a853-ca9ac3e42b00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Brood and Barley",
      "poi_type": "Restaurants",
      "poi_address": "411 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Casual gastropub specializing in sliders, burgers and steaks, plus beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-a6b4-74fd-afd3-599f0971ce7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-a6b4-74fd-afd3-599f0971ce7c",
        "storage_key": "property/6737460151191765/019e1e39-a6b4-74fd-afd3-599f0971ce7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broodandbarley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11202043947735015600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brood-and-barley",
      "poi_latitude": "34.7575145",
      "poi_longitude": "-92.2678324",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-400-8967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-035a-771c-8b98-ae4e6477ac9d",
        "storage_key": "property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_-HGX690ocRsGAPl56ndZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_b62d02af-0b28-4912-b535-121d4483bf1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Skinny J's Argenta",
      "poi_type": "Restaurants",
      "poi_address": "314a Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Casual restaurant offering comfort food with vegetarian options, plus a bar with a wide selection of beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b07a-712c-99dd-0bc6dda9e4e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b07a-712c-99dd-0bc6dda9e4e0",
        "storage_key": "property/6737460151191765/019e1e39-b07a-712c-99dd-0bc6dda9e4e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://skinnyjs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17305208340775788841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skinny-js-argenta",
      "poi_latitude": "34.7567056",
      "poi_longitude": "-92.2676099",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-916-2658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ84NY4G80ocRKWERjExzKPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7ec413e8-916d-47f0-b678-c57fc419e855",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Waldo's Chicken and Beer",
      "poi_type": "Restaurants",
      "poi_address": "4221 Warden Rd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Casual eatery specializing in fried and fire-roasted chicken plus Southern fare like mac 'n' cheese and collard greens.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b398-7310-8f99-e326329f44c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b398-7310-8f99-e326329f44c6",
        "storage_key": "property/6737460151191765/019e1e39-b398-7310-8f99-e326329f44c6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://waldoschicken.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12240644425651567184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waldos-chicken-and-beer",
      "poi_latitude": "34.793251",
      "poi_longitude": "-92.223244",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-313-2390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd50-7489-9d4b-106f6b082a9f",
        "storage_key": "property/6737460151191765/019e1e2e-dd50-7489-9d4b-106f6b082a9f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRZt1kO_0ocRULrTXECB36k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_d671122f-121c-44be-9654-b40ae09acd8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 Club Manor Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b6b4-7303-98ce-6190bc46349a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b6b4-7303-98ce-6190bc46349a",
        "storage_key": "property/6737460151191765/019e1e39-b6b4-7303-98ce-6190bc46349a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/maumelle/6747",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498684364639749789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "34.8536045",
      "poi_longitude": "-92.4053388",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-391-7013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd5e-74f8-851f-aa17c882bad5",
        "storage_key": "property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDaSNF2mf0ocRncZY3ktAT0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_558c2177-cf74-4736-ac04-7a458162bf4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Maumelle Family Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1701 Club Manor Dr #1, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.maumellefamilypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15330986485439888877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maumelle-family-pharmacy",
      "poi_latitude": "34.8545338",
      "poi_longitude": "-92.4052508",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-851-4949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036e-7688-8ef0-b59f3994fdf6",
        "storage_key": "property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndNFRGmf0ocR7X31QPuawtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_039db799-9b52-449c-b97a-724e8d289a72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 Commons Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b3ab-761d-a481-ae23e11ee905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b3ab-761d-a481-ae23e11ee905",
        "storage_key": "property/6737460151191765/019e1e39-b3ab-761d-a481-ae23e11ee905.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-115+commons+dr-maumelle-ar-72113/id=12418",
      "poi_directions_map_url": "https://maps.google.com/?cid=8284744998251973693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.8468726",
      "poi_longitude": "-92.4063331",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-803-3274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH-hymxaf0ocRPcyAc65T-XI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_d13a76a4-2305-4571-9560-c00b7d3c1c47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "110 Commons Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b3a5-7041-8e0a-0c581971b2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b3a5-7041-8e0a-0c581971b2cc",
        "storage_key": "property/6737460151191765/019e1e39-b3a5-7041-8e0a-0c581971b2cc.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/maumelle/maumelle/025/00606?cid=loc_02500606_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355815281318694081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.8478635",
      "poi_longitude": "-92.4084011",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-210-7670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4d-708d-be41-72580e822b01",
        "storage_key": "property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSd89Zmqf0ocRwQzIM7rR9XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e4bb9ec1-bf33-4bdf-9951-d6caa8dd8b78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "117 Audubon Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_long_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b470-74bf-bcb9-a5eec165fe97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b470-74bf-bcb9-a5eec165fe97",
        "storage_key": "property/6737460151191765/019e1e39-b470-74bf-bcb9-a5eec165fe97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://corporate.walmart.com/galleries/neighborhood-market",
      "poi_directions_map_url": "https://maps.google.com/?cid=5480583817230194355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "34.851714",
      "poi_longitude": "-92.405317",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-851-6673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4d-708d-be41-72580e822b01",
        "storage_key": "property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8Meymif0ocRs5bCw_HxDkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_e2a27db0-f32d-4e3d-9c33-67c637f8294b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "12001 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "Big-box store stocking electronics, furniture, clothes and groceries, as well as a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b603-7685-9fa5-3aee9d9ae453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b603-7685-9fa5-3aee9d9ae453",
        "storage_key": "property/6737460151191765/019e1e39-b603-7685-9fa5-3aee9d9ae453.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4460-north-little-rock-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11657353464268244131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.8317082",
      "poi_longitude": "-92.3946067",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-851-6102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd5e-74f8-851f-aa17c882bad5",
        "storage_key": "property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe4UJD_Ch0ocRo8TgYjY9x6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8f5c7def-1e06-43b4-8fe1-6ef34fd4192f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4220 McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b866-72a6-b9c4-d3d0d084e7ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b866-72a6-b9c4-d3d0d084e7ee",
        "storage_key": "property/6737460151191765/019e1e39-b866-72a6-b9c4-d3d0d084e7ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/north-little-rock/4220-e-mccain-blvd/fl07",
      "poi_directions_map_url": "https://maps.google.com/?cid=3163722864516566669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.78773",
      "poi_longitude": "-92.22072",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4d-708d-be41-72580e822b01",
        "storage_key": "property/6737460151191765/019e1e2e-dd4d-708d-be41-72580e822b01.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwJv-Q-_0ocRjY5K4y7N5ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_94c75c07-67f2-4f9c-ba46-43c1dc4b0feb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "4229 McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-bb60-768b-a005-cabefb43ea14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-bb60-768b-a005-cabefb43ea14",
        "storage_key": "property/6737460151191765/019e1e39-bb60-768b-a005-cabefb43ea14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ar/north-little-rock/4229-e-mccain-blvd-222.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=4555496740475421727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "34.791344",
      "poi_longitude": "-92.221029",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-955-2109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd5e-74f8-851f-aa17c882bad5",
        "storage_key": "property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL_VZi4K-0ocRH8R8PyZgOD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_6880ae02-3db8-4830-89b6-1b9c02870f27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Mattress Firm Maumelle",
      "poi_type": "Shopping & Retail",
      "poi_address": "11951 Maumelle Blvd Ste A, Maumelle, AR 72113, USA",
      "poi_short_description": "Chain retailer selling a wide array of branded spring, memory foam & adjustable mattresses.",
      "poi_long_description": "Chain retailer selling a wide array of branded spring, memory foam & adjustable mattresses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b862-710f-8797-41a28b48fea5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b862-710f-8797-41a28b48fea5",
        "storage_key": "property/6737460151191765/019e1e39-b862-710f-8797-41a28b48fea5.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.mattressfirm.com/en-us/stores/ar/maumelle/064008?utm_source=Google%20My%20Business&utm_medium=organic&utm_campaign=GMB&utm_term=maumelle%20ar&utm_kxconfid=uflnw2ovk",
      "poi_directions_map_url": "https://maps.google.com/?cid=4282712679916035409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mattress-firm-maumelle",
      "poi_latitude": "34.8302082",
      "poi_longitude": "-92.3938979",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-803-9384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd5e-74f8-851f-aa17c882bad5",
        "storage_key": "property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjck3oOWh0ocRUd102X1Abzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_f7e22e03-9704-4391-bf2a-78e6212f1009",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Petsense by Tractor Supply",
      "poi_type": "Shopping & Retail",
      "poi_address": "13300 Crystal Hill Rd, North Little Rock, AR 72113, USA",
      "poi_short_description": "Chain retailer featuring food, bedding & toys for dogs & cats, plus supplies for pet fish & birds.",
      "poi_long_description": "Chain retailer featuring food, bedding & toys for dogs & cats, plus supplies for pet fish & birds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-b800-770d-bc96-d22a92fae724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-b800-770d-bc96-d22a92fae724",
        "storage_key": "property/6737460151191765/019e1e39-b800-770d-bc96-d22a92fae724.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.petsense.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13419858005911153773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsense-by-tractor-supply",
      "poi_latitude": "34.8303436",
      "poi_longitude": "-92.3910225",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-753-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd5e-74f8-851f-aa17c882bad5",
        "storage_key": "property/6737460151191765/019e1e2e-dd5e-74f8-851f-aa17c882bad5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD8_uKOWh0ocRbSyEQsHpPLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_d367f4c9-c4a1-48eb-a519-1f911556a92b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Academics Plus Charter Schools, Inc",
      "poi_type": "Education",
      "poi_address": "600 Edgewood Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.academicsplus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14643160011423478669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academics-plus-charter-schools-inc",
      "poi_latitude": "34.862572",
      "poi_longitude": "-92.4044777",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-803-9730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeVH2UxOf0ocRjfMZlnL0Nss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fad81a5b-986d-4db4-8cf1-e12376af0d25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Pine Forest Elementary School",
      "poi_type": "Education",
      "poi_address": "400 Pine Forest Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-bab8-70e4-b108-32b32c93c1a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-bab8-70e4-b108-32b32c93c1a1",
        "storage_key": "property/6737460151191765/019e1e39-bab8-70e4-b108-32b32c93c1a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pineforest.pcssd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9993979593001915584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-forest-elementary-school",
      "poi_latitude": "34.8655602",
      "poi_longitude": "-92.4020647",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-851-5380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi1pM-RWf0ocRwNRhTX2_sYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_96906238-83cf-401a-8b74-7416723bb4ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Maumelle Middle School",
      "poi_type": "Education",
      "poi_address": "1000 Carnahan Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mms.pcssd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16573523077304693931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maumelle-middle-school",
      "poi_latitude": "34.857526",
      "poi_longitude": "-92.3886148",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-851-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhWb_00ef0ocRqzR8s237AOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4a75ef54-e1ca-43d2-8e74-3f08d2bb5abf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Maumelle High School",
      "poi_type": "Education",
      "poi_address": "100 Victory Ln, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-bdc5-707b-a0e8-0bc5a66c3f92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-bdc5-707b-a0e8-0bc5a66c3f92",
        "storage_key": "property/6737460151191765/019e1e39-bdc5-707b-a0e8-0bc5a66c3f92.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://mhs.pcssd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10482368725009736933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maumelle-high-school",
      "poi_latitude": "34.8627538",
      "poi_longitude": "-92.384935",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-851-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlf8ZKneY0ocR5aTeQtHaeJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f37b5586-1ea2-4e7b-905d-f902c3a54142",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Maumelle Charter High School",
      "poi_type": "Education",
      "poi_address": "9701 White Oak Crossing, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.academicsplus.org/o/mchs",
      "poi_directions_map_url": "https://maps.google.com/?cid=844503959923794977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maumelle-charter-high-school",
      "poi_latitude": "34.8437019",
      "poi_longitude": "-92.3719116",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-427-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtSDdptSZ0ocRISSrjuBHuAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f857a41a-cc67-4633-96ad-3ac2baf0b425",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Central Arkansas Christian Schools",
      "poi_type": "Education",
      "poi_address": "1 Windsong Dr, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c274-767f-ad50-55512bf6257d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c274-767f-ad50-55512bf6257d",
        "storage_key": "property/6737460151191765/019e1e39-c274-767f-ad50-55512bf6257d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cacmustangs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8511481949218560822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arkansas-christian-schools",
      "poi_latitude": "34.8155479",
      "poi_longitude": "-92.3550643",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-758-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTSIdPl2i0ocRNltSr7zbHnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2d17ed6c-cdf7-40b4-8912-f64652017474",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Kid's Academy",
      "poi_type": "Education",
      "poi_address": "10355 Riverview Corporate Dr, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-bf5c-75df-b4a8-0b3f4b294721.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-bf5c-75df-b4a8-0b3f4b294721",
        "storage_key": "property/6737460151191765/019e1e39-bf5c-75df-b4a8-0b3f4b294721.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11125823847716414367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-academy",
      "poi_latitude": "34.8210103",
      "poi_longitude": "-92.3753828",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-753-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTeYuPBmi0ocRn-O0pNfdZpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_81f45f1d-8e59-439a-a0bb-cd75931430bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Little Scholars Academy of Maumelle",
      "poi_type": "Education",
      "poi_address": "10910 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c269-757e-a8b5-f5e17c888ac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c269-757e-a8b5-f5e17c888ac8",
        "storage_key": "property/6737460151191765/019e1e39-c269-757e-a8b5-f5e17c888ac8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lilscholarsmaumelle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5222848122955938801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-scholars-academy-of-maumelle",
      "poi_latitude": "34.8241018",
      "poi_longitude": "-92.3821705",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-803-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwxDPa2yf0ocR8buaLLJIe0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_10c4cc5d-4890-4db8-8070-a7fce9909f53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "First United Methodist Church",
      "poi_type": "Education",
      "poi_address": "6701 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c39c-73ab-ad60-1bb66bc3e37c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c39c-73ab-ad60-1bb66bc3e37c",
        "storage_key": "property/6737460151191765/019e1e39-c39c-73ab-ad60-1bb66bc3e37c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nlrfumc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9749409735301940860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-united-methodist-church",
      "poi_latitude": "34.816492",
      "poi_longitude": "-92.2394484",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-835-2201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036a-74ac-9f6a-af1ba31ae449.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036a-74ac-9f6a-af1ba31ae449",
        "storage_key": "property/6737460151191765/019e1e3a-036a-74ac-9f6a-af1ba31ae449.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJGT67esG90ocRfEZo6n_cTIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_91380e9e-b93e-4f49-92a4-6d00ee069fe4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "University of Arkansas – Pulaski Technical College",
      "poi_type": "Education",
      "poi_address": "3000 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-af53-75ec-a5fa-2cbad83f15b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-af53-75ec-a5fa-2cbad83f15b4",
        "storage_key": "property/6737460151191765/019e1e2e-af53-75ec-a5fa-2cbad83f15b4.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.uaptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922972585545535160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas--pulaski-technical-college",
      "poi_latitude": "34.78212980000001",
      "poi_longitude": "-92.2993636",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-812-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ_E4js280ocRuI4JIcgycTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ed787575-62b2-44e6-b6e6-8112cd4c8f33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Arkansas Inland Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "120 Riverfront Park Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_long_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c217-73bc-9b19-40c9e7fab6c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c217-73bc-9b19-40c9e7fab6c2",
        "storage_key": "property/6737460151191765/019e1e39-c217-73bc-9b19-40c9e7fab6c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/arkansas-inland-maritime-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401581648013172689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-inland-maritime-museum",
      "poi_latitude": "34.7522251",
      "poi_longitude": "-92.2669543",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-371-8320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd54-7398-8f01-e05d19ecd4c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd54-7398-8f01-e05d19ecd4c2",
        "storage_key": "property/6737460151191765/019e1e2e-dd54-7398-8f01-e05d19ecd4c2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa_JEH670ocR0R-oeLIgeYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9b299d9e-b1f0-48eb-8702-790bb40f78ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Argenta Plaza",
      "poi_type": "Entertainment",
      "poi_address": "510 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Space for various events, along with an LED-lit plaza featuring a splash pad and swing benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-cb14-705e-a83c-74bd94572b72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-cb14-705e-a83c-74bd94572b72",
        "storage_key": "property/6737460151191765/019e1e39-cb14-705e-a83c-74bd94572b72.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.northlittlerock.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843491569430379576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argenta-plaza",
      "poi_latitude": "34.7585258",
      "poi_longitude": "-92.2674137",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-758-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJId1SYYO90ocRODy3VYQcdic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_3ff954f7-e54a-4ffe-897d-20825af266cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Birdies Cabaret Theater and Lounge",
      "poi_type": "Entertainment",
      "poi_address": "301 N Main St #102, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c9e5-7196-9f57-19dbe74ec1e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c9e5-7196-9f57-19dbe74ec1e5",
        "storage_key": "property/6737460151191765/019e1e39-c9e5-7196-9f57-19dbe74ec1e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://birdiescabaret.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12665914922848314268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdies-cabaret-theater-and-lounge",
      "poi_latitude": "34.7563692",
      "poi_longitude": "-92.2680017",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-480-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-035a-771c-8b98-ae4e6477ac9d",
        "storage_key": "property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_OYmPm90ocRnGOx84Nexq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_b09b8653-51a5-41e6-9bf5-33388b20a0f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Four Quarter Bar",
      "poi_type": "Entertainment",
      "poi_address": "415 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_long_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-abcb-7638-9ab8-0dd60a1bc320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-abcb-7638-9ab8-0dd60a1bc320",
        "storage_key": "property/6737460151191765/019e1e39-abcb-7638-9ab8-0dd60a1bc320.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fourquarterbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9814059172389972854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-quarter-bar",
      "poi_latitude": "34.75767390000001",
      "poi_longitude": "-92.2679825",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-313-4704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-035a-771c-8b98-ae4e6477ac9d",
        "storage_key": "property/6737460151191765/019e1e3a-035a-771c-8b98-ae4e6477ac9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-V54oO80ocRduv39tGKMog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_e88face3-8850-46b5-969d-73ca20d29a4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Flyway Brewing",
      "poi_type": "Entertainment",
      "poi_address": "314 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ab67-7567-a1d5-1931bfaaec35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ab67-7567-a1d5-1931bfaaec35",
        "storage_key": "property/6737460151191765/019e1e39-ab67-7567-a1d5-1931bfaaec35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywaybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212740221938584033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flyway-brewing",
      "poi_latitude": "34.7567912",
      "poi_longitude": "-92.2688016",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-812-3192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yyyxIO80ocR4UmasGs62n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_0f7ac843-2bad-4d6a-aee3-ceb6661e162f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Diamond Bear Brewing Co.",
      "poi_type": "Entertainment",
      "poi_address": "600 N Broadway St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Microbrewery since 2000 offering renowned European-style brews on tap & in bottles, plus tours.",
      "poi_long_description": "Microbrewery since 2000 offering renowned European-style brews on tap & in bottles, plus tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-a660-74ae-a5e2-ae38bb6f24b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-a660-74ae-a5e2-ae38bb6f24b7",
        "storage_key": "property/6737460151191765/019e1e39-a660-74ae-a5e2-ae38bb6f24b7.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://diamondbear.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12952325734298677333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "diamond-bear-brewing-co",
      "poi_latitude": "34.7591654",
      "poi_longitude": "-92.2722695",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-708-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiV2vCl670ocRVfAFiKHnv7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_8665ac80-aaea-4a34-9034-0a43298c8021",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Museum of Discovery",
      "poi_type": "Entertainment",
      "poi_address": "500 President Clinton Ave Ste. 150, Little Rock, AR 72201, USA",
      "poi_short_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_long_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-cb6b-7040-9153-698187eddea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-cb6b-7040-9153-698187eddea4",
        "storage_key": "property/6737460151191765/019e1e39-cb6b-7040-9153-698187eddea4.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.museumofdiscovery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16338434694446452897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery",
      "poi_latitude": "34.7476729",
      "poi_longitude": "-92.2646549",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-396-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd54-7398-8f01-e05d19ecd4c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd54-7398-8f01-e05d19ecd4c2",
        "storage_key": "property/6737460151191765/019e1e2e-dd54-7398-8f01-e05d19ecd4c2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUmT0ni70ocRoRBmNMrHveI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_129b1cac-0a7a-4909-ade8-44a791f878bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Springhill Dr, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-cbe8-746a-bbc8-5063af91905b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-cbe8-746a-bbc8-5063af91905b",
        "storage_key": "property/6737460151191765/019e1e39-cbe8-746a-bbc8-5063af91905b.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-medical-center-north-little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673750733774113147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-north-little-rock",
      "poi_latitude": "34.7835092",
      "poi_longitude": "-92.2224382",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-202-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd6f-710f-aad6-977e2849e892",
        "storage_key": "property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23mhdJ2-0ocRe8lz2iQ14q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0edea945-48e7-4043-b056-1cf754f7dd5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "HealthCARE Express Urgent Care - Maumelle, AR",
      "poi_type": "Health and Wellness",
      "poi_address": "11819 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d262-725f-92b1-d07ae17772e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d262-725f-92b1-d07ae17772e3",
        "storage_key": "property/6737460151191765/019e1e39-d262-725f-92b1-d07ae17772e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gohce.com/locations/arkansas/maumelle/maumelle/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17436701077163080292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthcare-express-urgent-care---maumelle-ar",
      "poi_latitude": "34.8279516",
      "poi_longitude": "-92.3902718",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-771-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN85QDvCh0ocRZPr5_j6b-_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8d6e9923-a87d-4b53-9c4d-867e916c87e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Baptist Health Urgent Care - North Little Rock (JFK)",
      "poi_type": "Health and Wellness",
      "poi_address": "5505 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.urgentteam.com/locations/baptist-health-urgent-care-north-little-rock-john-f-kennedy-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7727974723384914706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-urgent-care---north-little-rock-jfk",
      "poi_latitude": "34.805759",
      "poi_longitude": "-92.2525199",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-992-9150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2pvk6m90ocREjOO_BBIP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_12ae648c-abd9-43cd-8eab-73b3f0ea299e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12001 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d0d1-701f-a8ac-11927ea264ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d0d1-701f-a8ac-11927ea264ae",
        "storage_key": "property/6737460151191765/019e1e39-d0d1-701f-a8ac-11927ea264ae.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/4460-north-little-rock-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15358782579368660012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "34.831676",
      "poi_longitude": "-92.3944958",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-851-6459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036e-7688-8ef0-b59f3994fdf6",
        "storage_key": "property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4UJD_Ch0ocRLAy6sWFbJdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3ff5f8f3-aa44-484b-ab8f-5469cc790930",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Sam's Club Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5600 Landers Rd, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d262-725f-92b1-cf0974534d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d262-725f-92b1-cf0974534d31",
        "storage_key": "property/6737460151191765/019e1e39-d262-725f-92b1-cf0974534d31.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/8266-n-little-rock-ar/pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=10650188938685017592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-pharmacy",
      "poi_latitude": "34.8054936",
      "poi_longitude": "-92.2070597",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-955-9451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036e-7688-8ef0-b59f3994fdf6",
        "storage_key": "property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcavM8ma-0ocR-G0doWkSzZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ef5a9428-f67f-4dac-bc8c-ab5a4344e5a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Medicine Man Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2520 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d331-7259-87b7-6a4134055b7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d331-7259-87b7-6a4134055b7d",
        "storage_key": "property/6737460151191765/019e1e39-d331-7259-87b7-6a4134055b7d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rxmedman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6106126676321809087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medicine-man-pharmacy",
      "poi_latitude": "34.7785534",
      "poi_longitude": "-92.2663562",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-758-7581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036e-7688-8ef0-b59f3994fdf6",
        "storage_key": "property/6737460151191765/019e1e3a-036e-7688-8ef0-b59f3994fdf6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1maAOy80ocRv7KyR9xRvVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ec58b8c8-4daf-464e-941e-6495a5be2df3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Rock City Complete Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9000 Commerce Cove, North Little Rock, AR 72113, USA",
      "poi_short_description": "CrossFit, bootcamp and personal training classes are offered at this fitness studio with a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d54b-723d-b3fa-c4e59355352f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d54b-723d-b3fa-c4e59355352f",
        "storage_key": "property/6737460151191765/019e1e39-d54b-723d-b3fa-c4e59355352f.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://rockcitycompletefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4646841560244393608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-city-complete-fitness",
      "poi_latitude": "34.8409384",
      "poi_longitude": "-92.3783618",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-200-4483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ94I52hWi0ocRiJbjbcflfEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_72ac1385-98da-404d-8d6a-c7201f6cb165",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Bare Fit of Maumelle",
      "poi_type": "Health and Wellness",
      "poi_address": "29 Collins Industrial Pl Suite D, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d6c5-738e-93e6-abae2b23167a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d6c5-738e-93e6-abae2b23167a",
        "storage_key": "property/6737460151191765/019e1e39-d6c5-738e-93e6-abae2b23167a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.barefitmaumelle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10928084044420269108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bare-fit-of-maumelle",
      "poi_latitude": "34.8321681",
      "poi_longitude": "-92.3889699",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 870-219-3464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76MeINaf0ocRNMRI94laqJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53369ba5-38dd-4e1a-ac36-180c87fdafb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Yoga Maumelle",
      "poi_type": "Health and Wellness",
      "poi_address": "3101 Club Manor Dr A, Maumelle, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-dc9d-7101-acd0-a9a53b3eb6db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-dc9d-7101-acd0-a9a53b3eb6db",
        "storage_key": "property/6737460151191765/019e1e39-dc9d-7101-acd0-a9a53b3eb6db.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.yogamaumelle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15138506122404378745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-maumelle",
      "poi_latitude": "34.85120879999999",
      "poi_longitude": "-92.4071576",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-271-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTRI5Z8af0ocReTj9bxzHFtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_6c86e4e5-6e66-4347-bb89-0d1bae2e092b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "HOTWORX - North Little Rock, AR (Maumelle Blvd)",
      "poi_type": "Health and Wellness",
      "poi_address": "11761 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d5f9-7225-8e83-c741b789ba3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d5f9-7225-8e83-c741b789ba3d",
        "storage_key": "property/6737460151191765/019e1e39-d5f9-7225-8e83-c741b789ba3d.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "http://hotworx.net/studio/northlittlerock-maumelleblvd?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4415385101388076277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---north-little-rock-ar-maumelle-blvd",
      "poi_latitude": "34.82803",
      "poi_longitude": "-92.389252",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-615-8082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxEgAP2h0ocR9dTJIluZRj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_738d702c-b061-4436-8ab5-36a43868e828",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Burns Park RV Park and Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4101 Arlene Laman Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-dc56-7678-9647-2ea4d744f6ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-dc56-7678-9647-2ea4d744f6ba",
        "storage_key": "property/6737460151191765/019e1e39-dc56-7678-9647-2ea4d744f6ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nlrpr.org/rvpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=4393116755507183740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-park-rv-park-and-campground",
      "poi_latitude": "34.7970881",
      "poi_longitude": "-92.3140544",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-771-0702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-0374-7326-aa4f-e4cdbef730df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-0374-7326-aa4f-e4cdbef730df",
        "storage_key": "property/6737460151191765/019e1e3a-0374-7326-aa4f-e4cdbef730df.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJuykQp9Oi0ocRfIDS1Gl89zw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rv_park"
    },
    {
      "id": "custom_c3be55f3-34ab-4913-9fbb-620347616dbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Emerald Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3098 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park with a paved trail along a river, popular for walking, hiking, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d847-77fa-a79b-20c0450bfc29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d847-77fa-a79b-20c0450bfc29",
        "storage_key": "property/6737460151191765/019e1e39-d847-77fa-a79b-20c0450bfc29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/emerald-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14860266810328559427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerald-park",
      "poi_latitude": "34.7842215",
      "poi_longitude": "-92.3007033",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xyQW8u80ocRQy8pUe5FOs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_849b944f-ee70-4b6c-8648-5ccacf1bf586",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Big Rock Quarry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bay Oaks Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ddd4-732e-942f-234d860cdad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ddd4-732e-942f-234d860cdad3",
        "storage_key": "property/6737460151191765/019e1e39-ddd4-732e-942f-234d860cdad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nlrpr.org/cms/one.aspx?portalId=96195&pageId=200421",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983319870280631652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rock-quarry",
      "poi_latitude": "34.7800996",
      "poi_longitude": "-92.3045839",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxscPIej0ocRZAXJi9Mpq3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5ba9a4ec-14d2-4ec8-bc12-b121cc21e728",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Riverview Skateboard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2801 River Rd, North Little Rock, AR 72114, USA",
      "poi_short_description": "Recreational venue with a skate park, a playground, and a bike/walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e168-74d8-87f8-29ca85054200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e168-74d8-87f8-29ca85054200",
        "storage_key": "property/6737460151191765/019e1e39-e168-74d8-87f8-29ca85054200.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/riverview-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11151943499546355846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-skateboard-park",
      "poi_latitude": "34.76926340000001",
      "poi_longitude": "-92.2967257",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVliDSy90ocRhuiv_Yapw5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_9d2ed9cb-14bd-4dc2-b82c-efdb368ad597",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Julius Breckling Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_long_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-dca2-74fd-ab1e-56f7dc9068ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-dca2-74fd-ab1e-56f7dc9068ac",
        "storage_key": "property/6737460151191765/019e1e39-dca2-74fd-ab1e-56f7dc9068ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/park-facility-trail-information/riverfront/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13698303629607314796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-breckling-riverfront-park",
      "poi_latitude": "34.7484093",
      "poi_longitude": "-92.266912",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ894yxn670ocRbCUwDJMmGr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e3397347-3c86-463b-97cf-181380da2674",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Campbell Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4100 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park with paved riverside trails for walking, running, and biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e22f-745e-ab7e-f091fa8c1cda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e22f-745e-ab7e-f091fa8c1cda",
        "storage_key": "property/6737460151191765/019e1e39-e22f-745e-ab7e-f091fa8c1cda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/campbell-lake-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6847212567647828084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campbell-lake-park",
      "poi_latitude": "34.7956794",
      "poi_longitude": "-92.3516307",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8kpt7Kj0ocRdDg9XI0vBl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ca9842cb-f4b4-4ff0-97d9-51ef18fc75e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-cbe3-71ad-85bb-a701d1eeece2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-cbe3-71ad-85bb-a701d1eeece2",
        "storage_key": "property/6737460151191765/019e1e39-cbe3-71ad-85bb-a701d1eeece2.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_e56edbf9-b0d0-4ee4-9543-70431a205c44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "The Old Mill",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3800 Lakeshore Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_long_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-d0e2-7636-95a5-274aaa429874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-d0e2-7636-95a5-274aaa429874",
        "storage_key": "property/6737460151191765/019e1e39-d0e2-7636-95a5-274aaa429874.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/old-mill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753738084307160303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-mill",
      "poi_latitude": "34.7913123",
      "poi_longitude": "-92.249526",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xsnok680ocR78zj0OoX374",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_0460f1c6-1084-4739-ba56-d0f14737c921",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Pinnacle Mountain State Park Visitor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Pinnacle Valley Rd, Little Rock, AR 72223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e276-71c8-a9ed-bb1751bc4a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e276-71c8-a9ed-bb1751bc4a88",
        "storage_key": "property/6737460151191765/019e1e39-e276-71c8-a9ed-bb1751bc4a88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.arkansasstateparks.com/pinnaclemountain/",
      "poi_directions_map_url": "https://maps.google.com/?cid=675723267676754693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-mountain-state-park-visitor-center",
      "poi_latitude": "34.844636",
      "poi_longitude": "-92.4626007",
      "poi_miles_from_property": "13",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 501-868-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QHJSwJgzYcRBdNWWLumYAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_623ce6c6-4b4b-4c32-adee-c313268faa8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Lake Willastein Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "309 Lake Willastein Dr, Maumelle, AR 72113, USA",
      "poi_short_description": "Lake and riverside park with walking trails and fishing, plus a playground, boat moorings and barbecues, plus picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e41c-763b-9942-5f1a3ae01db1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e41c-763b-9942-5f1a3ae01db1",
        "storage_key": "property/6737460151191765/019e1e39-e41c-763b-9942-5f1a3ae01db1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://maumelleparksandrec.recdesk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9735631006385348296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-willastein-park",
      "poi_latitude": "34.8521112",
      "poi_longitude": "-92.4120135",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-851-6990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6AfCnGf0ocRyJ7gl9HoG4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_939e4a9b-6147-4662-8e3d-975af713fcd1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Rock Region METRO",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e6c1-7787-8076-d72eaa156f50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e6c1-7787-8076-d72eaa156f50",
        "storage_key": "property/6737460151191765/019e1e39-e6c1-7787-8076-d72eaa156f50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174036123689371751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-region-metro",
      "poi_latitude": "34.7624459",
      "poi_longitude": "-92.2689822",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtavgzIW80ocRZ0i37YsCcHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_183edd2e-e10d-4c2f-8617-27b2de329531",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-e84f-7264-8688-e421df29802a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-e84f-7264-8688-e421df29802a",
        "storage_key": "property/6737460151191765/019e1e39-e84f-7264-8688-e421df29802a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_6d1524f8-b4ec-402b-b1f8-4a48a2c66b0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ee9b-7544-8f81-b7c17b7f942a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ee9b-7544-8f81-b7c17b7f942a",
        "storage_key": "property/6737460151191765/019e1e39-ee9b-7544-8f81-b7c17b7f942a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-03a4-76d8-8067-e15254d07713.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-03a4-76d8-8067-e15254d07713",
        "storage_key": "property/6737460151191765/019e1e3a-03a4-76d8-8067-e15254d07713.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c099895a-f22e-4c69-82b3-8204d0f64f30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ee1d-7631-9831-5f053ef306c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ee1d-7631-9831-5f053ef306c7",
        "storage_key": "property/6737460151191765/019e1e39-ee1d-7631-9831-5f053ef306c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "14.8",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-036d-7749-8b66-f265d15953a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-036d-7749-8b66-f265d15953a9",
        "storage_key": "property/6737460151191765/019e1e3a-036d-7749-8b66-f265d15953a9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_f6a267a1-6ca4-4553-b0e0-d642689d450b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Simmons Bank Arena",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Simmons Bank Arena Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_long_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-c9d7-719e-9f90-9707ddac14ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-c9d7-719e-9f90-9707ddac14ca",
        "storage_key": "property/6737460151191765/019e1e39-c9d7-719e-9f90-9707ddac14ca.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://simmonsbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13831376352313287939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-bank-arena",
      "poi_latitude": "34.7550895",
      "poi_longitude": "-92.2643235",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-340-5660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTmHEoC80ocRAyVfuoLr8r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_8e89508f-9ea9-4702-b0b8-125331d257f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Transportation & Transit",
      "poi_address": "9723 Maumelle Blvd, North Little Rock, AR 72113, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-ef07-71ce-b26f-a93b0bc11d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-ef07-71ce-b26f-a93b0bc11d22",
        "storage_key": "property/6737460151191765/019e1e39-ef07-71ce-b26f-a93b0bc11d22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/north-little-rock/9723-maumelle-blvd/2741795?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6077434564144859721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "34.8223171",
      "poi_longitude": "-92.3692712",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-771-4021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-03b4-771b-91cc-e4ed7512cf36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-03b4-771b-91cc-e4ed7512cf36",
        "storage_key": "property/6737460151191765/019e1e3a-03b4-771b-91cc-e4ed7512cf36.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJHzaEfxai0ocRSQqJVYliV1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_d352510a-4525-483d-a339-02ffba35913e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Transportation & Transit",
      "poi_address": "5919 Crystal Hill Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f473-7399-b073-f2e83b92664f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f473-7399-b073-f2e83b92664f",
        "storage_key": "property/6737460151191765/019e1e39-f473-7399-b073-f2e83b92664f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10005795-5919-crystal-hill-rd/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=1985216264559529416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "34.817199",
      "poi_longitude": "-92.328219",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-753-7475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e3a-03b7-73cd-9f19-2d1532b8adff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e3a-03b7-73cd-9f19-2d1532b8adff",
        "storage_key": "property/6737460151191765/019e1e3a-03b7-73cd-9f19-2d1532b8adff.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyif2_Ki0ocRyA1mq6znjBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_9606103e-6094-4924-9107-bfc5052b2237",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Two Rivers Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "RH6X+QC, 6900 Two Rivers Park Road, Little Rock, AR 72223, USA",
      "poi_short_description": "Natural area with bike paths, picnic tables, a playground, and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-c994-7565-8fcd-a39c31acee30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-c994-7565-8fcd-a39c31acee30",
        "storage_key": "property/6737460151191765/019e1e2e-c994-7565-8fcd-a39c31acee30.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://pulaskicounty.net/two-rivers-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852413415211130700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "34.8114881",
      "poi_longitude": "-92.4017327",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd4f-717f-b2a3-41a3e3151c26",
        "storage_key": "property/6737460151191765/019e1e2e-dd4f-717f-b2a3-41a3e3151c26.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy13IPpah0ocRTN-bFZeFdjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d5b69b93-3ff2-427f-b498-115ce128f87c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f019-712d-86dc-cbdb987744e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f019-712d-86dc-cbdb987744e3",
        "storage_key": "property/6737460151191765/019e1e39-f019-712d-86dc-cbdb987744e3.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd6f-710f-aad6-977e2849e892",
        "storage_key": "property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4d09f8ee-99f6-4282-af1c-05a8869d60f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f1c5-70ee-9da7-0a3c3a7129d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f1c5-70ee-9da7-0a3c3a7129d4",
        "storage_key": "property/6737460151191765/019e1e39-f1c5-70ee-9da7-0a3c3a7129d4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd6f-710f-aad6-977e2849e892",
        "storage_key": "property/6737460151191765/019e1e2e-dd6f-710f-aad6-977e2849e892.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bc83cd55-feec-43b1-b907-887687322ca6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f33f-75ad-a286-9ff7458855c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f33f-75ad-a286-9ff7458855c2",
        "storage_key": "property/6737460151191765/019e1e39-f33f-75ad-a286-9ff7458855c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e",
        "storage_key": "property/6737460151191765/019e1e2e-dd72-75d9-97ab-cd3a1ecdda7e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c3b1ce81-cd5e-4383-9ddc-51ba14aa9822",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f4ca-75e9-9ab0-0a7c6ebcc51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f4ca-75e9-9ab0-0a7c6ebcc51a",
        "storage_key": "property/6737460151191765/019e1e39-f4ca-75e9-9ab0-0a7c6ebcc51a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_69d3846a-fe2a-4d32-ab2c-1c2be3d41d6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Windstream (Kinetic, Wholesale, Enterprise)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4005 N Rodney Parham Rd, Little Rock, AR 72212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f594-70eb-aa37-b96cb6e0f6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f594-70eb-aa37-b96cb6e0f6be",
        "storage_key": "property/6737460151191765/019e1e39-f594-70eb-aa37-b96cb6e0f6be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.windstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16791035967187703863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windstream-kinetic-wholesale-enterprise",
      "poi_latitude": "34.7871432",
      "poi_longitude": "-92.3974489",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 877-759-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVK6onOh0ocRN9gH2z--Bek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "telecommunications_service_provider"
    },
    {
      "id": "custom_8b17832e-983e-484c-a989-a4e3e69961e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Simmons Tower, 425 W Capitol Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f74c-726a-b4f7-054a553bf34d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f74c-726a-b4f7-054a553bf34d",
        "storage_key": "property/6737460151191765/019e1e39-f74c-726a-b4f7-054a553bf34d.webp",
        "width": 577,
        "height": 1280
      },
      "poi_business_url": "https://www.entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9158092095337438054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "entergy",
      "poi_latitude": "34.7440986",
      "poi_longitude": "-92.2756183",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-368-3749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3BWB2W70ocRZpvmMj0UGH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_663781e0-c06e-455c-b7e1-cecf29e37c51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Heifer International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-f7e5-7719-b460-6e749b5c0341.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-f7e5-7719-b460-6e749b5c0341",
        "storage_key": "property/6737460151191765/019e1e39-f7e5-7719-b460-6e749b5c0341.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heifer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15947581606820737385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heifer-international",
      "poi_latitude": "34.7447963",
      "poi_longitude": "-92.2561293",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-948-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6hY55Wj0ocRaXEaPfowUd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a46cd363-cd25-4297-a634-a35a0b0a6f53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "poi_name": "Winrock International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "325 W Capitol Ave suite 350, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e39-fd96-770a-a0f0-89e0a93e8bce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e39-fd96-770a-a0f0-89e0a93e8bce",
        "storage_key": "property/6737460151191765/019e1e39-fd96-770a-a0f0-89e0a93e8bce.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.winrock.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9444094363833907050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winrock-international",
      "poi_latitude": "34.7442149",
      "poi_longitude": "-92.2743487",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-280-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-dd68-71d3-9d8a-b5044c4103d9",
        "storage_key": "property/6737460151191765/019e1e2e-dd68-71d3-9d8a-b5044c4103d9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyAlB0yj0ocRareWdckpEIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9822adce-ac2a-4044-9c09-c749beea99eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_60b1f9b5-a8f1-47d1-a2c2-3e0b2628a318",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5d269dc5-3248-47cb-acba-84f47bfc7107",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_91e12463-5202-4ed0-a628-f6b05004d25f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_011f69a1-99f6-4e1b-95f0-523188b0027d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_dce4699a-91c5-4335-b928-3d4743d7f9e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1b8d690b-032d-4a9a-a71f-2a1ffddfc3e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "rating": "5",
      "name": "Jagger O",
      "text": "Maintenance is always quick and does a great job!",
      "date": "2026-05-06",
      "title": "false"
    },
    {
      "id": "custom_f0f24609-7091-4ece-a2e7-741ceb4721ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "rating": "5",
      "name": "Teauncaa Jackson",
      "text": "I want to take a moment to recognize Umble for the outstanding work he consistently delivers. He’s not only incredibly kind and approachable, but he goes above and beyond to make sure every request in my unit is handled quickly and efficiently. Even when he’s not inside working on a unit, you’ll find him outside putting in the same level of care—keeping the grounds looking clean, organized, and well-maintained. His work ethic and attention to detail truly don’t go unnoticed. Keep up the amazing work, Umble!",
      "date": "2026-05-06",
      "title": "false"
    },
    {
      "id": "custom_c785123f-4467-4323-bf98-4e438c43b294",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "rating": "5",
      "name": "Lilbaby _.jorden",
      "text": "Mr. hubel was so perfessional and fix what I needed done in a day great service",
      "date": "2026-04-22",
      "title": "false"
    },
    {
      "id": "custom_0630752d-01b9-4032-a1fe-dde991dd0f6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "rating": "5",
      "name": "CJ Review",
      "text": "I wanted to take a moment to share how truly impressed and grateful I am for the exceptional service provided by Umble. From the very beginning, he demonstrated not only professionalism but also a genuine commitment to getting the job done right.\n\nUmble is incredibly reliable, always showing up on time and ready to work with a positive attitude. What really stands out is his attention to detail—he doesn’t just fix the issue at hand, he makes sure everything is thoroughly checked and functioning properly before he leaves. It’s clear he takes pride in his work, and that level of care makes a huge difference.\n\nBeyond his skills, his customer service is outstanding. He is respectful, patient, and takes the time to explain what he’s doing in a way that’s easy to understand. No matter how big or small the issue is, he approaches every task with the same level of dedication and professionalism.\n\nIt’s not often you come across someone who consistently goes above and beyond, but Umble truly does. Having someone like him handling maintenance gives a great sense of comfort and trust, knowing things will be handled efficiently and correctly.\n\nOverall, I highly recommend Umble to anyone in need of maintenance services. His work ethic, kindness, and expertise make him a valuable asset, and it does not go unnoticed. Thank you for always delivering top-tier service! I live in units 7363",
      "date": "2026-04-29",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_110486ee-f5ad-4e47-9d62-1c317d2cd843",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019e1e2f-8c69-751c-b13a-074d927255e9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool and apartment buildings",
        "public_id": "019e1e2f-8c69-751c-b13a-074d927255e9",
        "storage_key": "property/6737460151191765/019e1e2f-8c69-751c-b13a-074d927255e9.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=66ba2b0c2aa99630269e5c83"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-dc31-7204-ae7c-6cc658a044ad",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "73twentyfive",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765"
    },
    {
      "lead_collector_id": "0198aa47-dc92-71ac-9f94-cea0b4667d0c",
      "lead_source": "FACEBOOK_ADS",
      "name": "73twentyfive",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765"
    },
    {
      "lead_collector_id": "0198aa47-dcf6-7495-b399-c493a5ec99c9",
      "lead_source": "LANDING_PAGE",
      "name": "73twentyfive",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-north-little-rock-ar",
      "search_query": "dog friendly apartments North Little Rock AR",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in North Little Rock",
      "h2_subtitle": "Explore dog-friendly living at 73TwentyFive. Our Bark Park ensures your furry friend has plenty of room to play right in North Little Rock, AR.",
      "page_copy": "At 73TwentyFive, we warmly welcome you and your four-legged friends to our dog-friendly community in North Little Rock, AR. Our on-site Bark Park is a favorite spot among our residents with pets, allowing dogs to frolic and make new friends safely. Whether you're strolling through our beautifully landscaped grounds or relaxing in our stylish apartments, you and your pet will feel right at home.\n\nApart from being a pet paradise, our amenities cater to every need. From stunning one, two, and three-bedroom layouts with upgraded flooring and modern appliances, to lavish amenities like two sparkling pools and a 24-hour fitness center, 73TwentyFive offers a lifestyle of comfort and convenience. Located in Pulaski County, it’s time to discover what makes our dog-friendly apartments in North Little Rock, AR the perfect place for both you and your furry companion.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments North Little Rock, AR",
      "seo_description": "Discover dog-friendly living at 73TwentyFive in North Little Rock, AR. Enjoy our Bark Park and pet-friendly amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "apartments-with-pools-north-little-rock-ar",
      "search_query": "apartments with pools North Little Rock AR",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in North Little Rock",
      "h2_subtitle": "Enjoy resort-style living at 73TwentyFive. Dive into our two sparkling pools in North Little Rock, AR.",
      "page_copy": "Experience the ultimate in luxury and relaxation at 73TwentyFive, where our residents can enjoy not just one, but two dazzling swimming pools. Nestled in North Little Rock, AR, our community offers a refreshing escape from the everyday hustle, allowing you to lounge poolside and soak up the sun.\n\nAlongside our incredible pools, 73TwentyFive boasts an array of stylish amenities including a 24-hour fitness center and a lively community atmosphere. Our beautifully designed one, two, and three-bedroom apartments feature upgraded flooring and appliances. Set in Pulaski County, our complex ensures a serene living experience with ample parking and a convenient location. Come see why our apartments with pools are the best place to call home in North Little Rock, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools North Little Rock, AR",
      "seo_description": "Dive into comfort at 73TwentyFive with two pools. Enjoy stylish living with top amenities in North Little Rock, AR. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-pulaski-county",
      "search_query": "24-hour fitness center Pulaski County",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center in Pulaski County",
      "h2_subtitle": "Stay active anytime at 73TwentyFive. Our 24-hour fitness center in Pulaski County is just steps from your door.",
      "page_copy": "Located in the heart of Pulaski County, 73TwentyFive offers a premier living experience with our state-of-the-art 24-hour fitness center. Residents can enjoy the flexibility of working out at their convenience, without the constraints of typical gym hours, making it easier than ever to maintain a healthy lifestyle.\n\nIn addition to our exceptional fitness center, our community features amenities designed to enhance your living experience. Choose from our stylish one, two, and three-bedroom apartments featuring upgraded flooring and modern appliances. Join us in enjoying our two sun-drenched pools and spacious Bark Park, all nestled in our vibrant community. Situated in North Little Rock, AR, 73TwentyFive is ready to meet all your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness Center Pulaski County",
      "seo_description": "Enjoy a 24-hour fitness center at 73TwentyFive in Pulaski County. Convenient, stylish living with top amenities in North Little Rock, AR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "upgraded-apartments-north-little-rock-72113",
      "search_query": "upgraded apartments North Little Rock 72113",
      "category": "Amenity",
      "h1_title": "Upgraded Apartments in North Little Rock, AR",
      "h2_subtitle": "Discover contemporary living at 73TwentyFive. Our upgraded apartments in North Little Rock, 72113 offer top-tier amenities for your lifestyle.",
      "page_copy": "Welcome to 73TwentyFive, where modern meets comfort in our upgraded apartments located in North Little Rock, within the 72113 ZIP code. Our community offers one, two, and three-bedroom floor plans that feature high-end finishes like upgraded flooring and state-of-the-art appliances, ensuring both style and functionality in your living space.\n\nBeyond your personal oasis, enjoy our remarkable community amenities including two refreshing pools, a 24-hour fitness center, and a spacious Bark Park. We provide ample parking and convenient access to local attractions, making 73TwentyFive the ideal place to call home. Experience the best of North Little Rock living at our upgraded apartments in the vibrant Pulaski County area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Upgraded Apartments North Little Rock, 72113",
      "seo_description": "Experience upgraded living at 73TwentyFive in North Little Rock, 72113. Enjoy modern amenities and stylish finishes. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "bark-park-apartments-north-little-rock",
      "search_query": "bark park apartments North Little Rock",
      "category": "Amenity",
      "h1_title": "Bark Park Apartments in North Little Rock",
      "h2_subtitle": "At 73TwentyFive, your furry friends will love our spacious Bark Park. Discover pet-friendly apartments in North Little Rock today.",
      "page_copy": "Embrace pet-friendly living at 73TwentyFive with our dedicated Bark Park, perfect for your four-legged companions. Located in North Little Rock, our apartments cater to both you and your pets, offering abundant space and amenities that make life enjoyable.\n\nOur community provides a welcoming environment with one, two, and three-bedroom apartments, all featuring modern upgrades like new flooring and top-tier appliances. Residents also benefit from two sparkling pools, a 24-hour fitness center, and ample parking. Discover apartment living that meets the needs of both you and your pets in the heart of Pulaski County, AR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bark Park Apartments North Little Rock",
      "seo_description": "Find pet-friendly living at 73TwentyFive with a Bark Park in North Little Rock. Enjoy top amenities for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-north-little-rock-ar",
      "search_query": "one bedroom apartments in North Little Rock AR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Little Rock",
      "h2_subtitle": "Experience stylish living in North Little Rock with our one-bedroom apartments at 73TwentyFive. Discover your perfect home today.",
      "page_copy": "At 73TwentyFive, we offer spacious one-bedroom apartments in North Little Rock, AR, designed with modern comfort in mind. Each apartment is equipped with upgraded appliances and flooring, providing a contemporary feel that matches your lifestyle.\n\nOur vibrant community boasts top amenities including two shimmering pools, a 24-hour fitness center, and a dedicated Bark Park. Nestled in Pulaski County, our location offers a perfect blend of tranquility and city convenience. Choose 73TwentyFive for a home that caters to all your needs in North Little Rock.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments North Little Rock, AR",
      "seo_description": "Discover one-bedroom apartments at 73TwentyFive in North Little Rock, AR. Enjoy modern amenities and stylish living in Pulaski County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-pulaski-county",
      "search_query": "two bedroom apartments Pulaski County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Pulaski County",
      "h2_subtitle": "Explore spacious two-bedroom apartments at 73TwentyFive in Pulaski County. Enjoy modern amenities and a convenient lifestyle.",
      "page_copy": "At 73TwentyFive, our two-bedroom apartments in Pulaski County offer the perfect blend of style and comfort. Each apartment is thoughtfully designed with contemporary features such as upgraded flooring and state-of-the-art appliances, ensuring a modern living experience.\n\nResidents at 73TwentyFive can relish in community perks that include two sparkling swimming pools, a fully-equipped 24-hour fitness center, and a welcoming Bark Park. Our ample parking facilities make life easy, while our prime North Little Rock location provides easy access to local attractions and conveniences. Choose our two-bedroom spaces for a comfortable lifestyle tailored to you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Pulaski County",
      "seo_description": "Find spacious two-bedroom apartments at 73TwentyFive in Pulaski County. Enjoy modern features and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191765",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-72113",
      "search_query": "three bedroom apartments near 72113",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 72113",
      "h2_subtitle": "Discover comfortable three-bedroom living at 73TwentyFive, conveniently located near 72113. Enjoy spacious layouts and modern amenities.",
      "page_copy": "Experience the ideal three-bedroom apartment living near the 72113 area at 73TwentyFive. Our apartments provide ample space and are equipped with upgraded flooring and high-end appliances, perfect for those who value style and functionality.\n\nLocated in North Little Rock, our vibrant community boasts two sparkling pools, a 24-hour fitness center, a dedicated Bark Park, and ample parking. These features, along with our close proximity to local attractions in Pulaski County, make 73TwentyFive the perfect choice for spacious living. Come see why our three-bedroom options are the right fit for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
      "featured_image_media": {
        "alt_text": "Living room with plush sectional, coffee table, and view into bedroom.",
        "public_id": "019d076d-ee21-756f-a0d2-116a50d16f49",
        "storage_key": "property/6737460151191765/019d076d-ee21-756f-a0d2-116a50d16f49.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 72113",
      "seo_description": "Find spacious three-bedroom apartments at 73TwentyFive near 72113. Enjoy modern amenities and a prime location in North Little Rock.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3356"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483359"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026525"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T6B8BVTJ"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-298-4940"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-298-4575"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-298-4689"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-298-4639"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-298-4638"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-298-4664"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-298-4498"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-298-4951"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-298-4582"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "501-298-4702"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-408-2719"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-426-6626"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-298-4464"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-361-1324"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-443-4592"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-550-8923"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-380-0618"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-790-4258"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-600-0695"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321266756"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-298-4624"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-285-8114"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ee69c4d34816001"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-298-1328"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-298-4697"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-298-4560"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-510-8543"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-298-4471"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-298-4541"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "501-298-4674"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-298-4693"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.73twentyfive.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191765/019e8523-fd95-74da-964c-f8938cef789c.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-298-4687"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-408-2719"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3356",
  "custom_repli_id": "5028483359",
  "custom_realpage_id": "5026525",
  "custom_knock_a_link": "https://www.73twentyfive.com?utm_knock=a",
  "custom_knock_g_link": "https://www.73twentyfive.com?utm_knock=g",
  "custom_knock_r_link": "https://www.73twentyfive.com?utm_knock=r",
  "custom_knock_w_link": "https://www.73twentyfive.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-T6B8BVTJ",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.73twentyfive.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.73twentyfive.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.73twentyfive.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.73twentyfive.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.73twentyfive.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.73twentyfive.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.73twentyfive.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-298-4940",
  "custom_knock_ads_link": "https://www.73twentyfive.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.73twentyfive.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "501-298-4575",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.73twentyfive.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.73twentyfive.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.73twentyfive.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.73twentyfive.com?utm_knock=psa",
  "custom_knock_r_number": "501-298-4689",
  "custom_knock_w_number": "501-298-4639",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-298-4638",
  "custom_knock_amap_link": "https://www.73twentyfive.com?utm_knock=amap",
  "custom_knock_ar_number": "501-298-4664",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-298-4498",
  "custom_knock_fb_number": "501-298-4951",
  "custom_knock_fl_number": "501-298-4582",
  "custom_knock_fr_number": "501-298-4702",
  "custom_knock_gp_number": "501-408-2719",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.73twentyfive.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "501-426-6626",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.73twentyfive.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-298-4464",
  "custom_knock_cfres_link": "https://www.73twentyfive.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-361-1324",
  "custom_knock_lgp_number": "501-443-4592",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.73twentyfive.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-550-8923",
  "custom_knock_psa_number": "501-380-0618",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "501-790-4258",
  "custom_knock_bandit_link": "https://www.73twentyfive.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.73twentyfive.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-600-0695",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321266756",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-298-4624",
  "custom_knock_cfres_number": "501-285-8114",
  "custom_knock_chatgpt_link": "https://www.73twentyfive.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ee69c4d34816001",
  "custom_knock_dirmail_link": "https://www.73twentyfive.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-298-1328",
  "custom_knock_propbro_link": "https://www.73twentyfive.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-298-4697",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-298-4560",
  "custom_knock_outbound_link": "https://www.73twentyfive.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.73twentyfive.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-510-8543",
  "custom_knock_dirmail_number": "501-298-4471",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "501-298-4541",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "501-298-4674",
  "custom_knock_revcards_number": "501-298-4693",
  "custom_knock_maintenance_link": "https://www.73twentyfive.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191765/019e8523-fd95-74da-964c-f8938cef789c.mp4",
  "custom_knock_maintenance_number": "501-298-4687",
  "custom_ppc_tracking_phone_number": "501-408-2719"
};

export const generatedAt = '2026-11-03T18:36:41.438Z';
